// import React, { useState, useEffect } from 'react';
// import { FaEdit, FaSignOutAlt, FaUserCircle } from 'react-icons/fa';
// import { IoArrowBackCircle } from 'react-icons/io5';
// import { Table, Modal, Pagination } from 'react-bootstrap';
// import logo from '../Images/Business_logo.png'
// import { MdDelete } from "react-icons/md";
// import axios from 'axios';
// import { useNavigate } from 'react-router-dom';
// import { QRCodeCanvas } from 'qrcode.react';

// const sections = [
//     "Menu Items", "Event Calendar", "Speakers & Sessions", "Networking",
//     "Stalls", "Online Quiz", "Notifications", "Help Desk",
//     "Gallery",
// ];

// const sectionData = {
//     "Event Calendar": "Manage and view all scheduled events in the calendar.",
//     "Networking": "Connect attendees and manage networking options.",
//     "Online Poll": "Create polls and monitor voting results.",
//     "Gallery": "Upload and view photos from the event."
// };

// const MenuItems = ({ onBack }) => {
//     const [showModal, setShowModal] = useState(false);
//     const [inputValue, setInputValue] = useState('');
//     const [item1, setItem1] = useState('');
//     const [item2, setItem2] = useState('');
//     const [item3, setItem3] = useState('');
//     const [item4, setItem4] = useState('');
//     const [item5, setItem5] = useState('');
//     const [items, setItems] = useState([]);
//     const [editItemId, setEditItemId] = useState(null);
//     const [currentPage, setCurrentPage] = useState(1);
//     const itemsPerPage = 10;

//     const handleShow = () => setShowModal(true);
//     const handleClose = () => {
//         setShowModal(false);
//         setInputValue('');
//         setItem1('');
//         setItem2('');
//         setItem3('');
//         setItem4('');
//         setItem5('');
//         setEditItemId(null);
//     };

//     const fetchItems = async () => {
//         try {
//             const response = await fetch('https://taaiappapi.emedha.in/pages/api/menuitems');
//             const data = await response.json();
//             setItems(data);
//         } catch (error) {
//             console.error('Error fetching items:', error);
//         }
//     };

//     useEffect(() => {
//         fetchItems();
//     }, []);

//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         if (inputValue) {
//             const itemData = { name: inputValue, item1, item2, item3, item4, item5 };
//             if (editItemId) {
//                 try {
//                     const response = await fetch(`https://taaiappapi.emedha.in/pages/api/api/menuitems/${editItemId}`, {
//                         method: 'PUT',
//                         headers: { 'Content-Type': 'application/json' },
//                         body: JSON.stringify(itemData),
//                     });
//                     if (response.ok) {
//                         const updatedItem = await response.json();
//                         setItems(items.map(item => (item.id === editItemId ? updatedItem : item)));
//                         handleClose();
//                     } else {
//                         console.error('Error updating item:', response.statusText);
//                     }
//                 } catch (error) {
//                     console.error('Error updating item:', error);
//                 }
//             } else {
//                 try {
//                     const response = await fetch('https://taaiappapi.emedha.in/pages/api/menuitems', {
//                         method: 'POST',
//                         headers: { 'Content-Type': 'application/json' },
//                         body: JSON.stringify(itemData),
//                     });
//                     if (response.ok) {
//                         const newItem = await response.json();
//                         setItems([...items, newItem]);
//                         handleClose();
//                     } else {
//                         console.error('Error adding item:', response.statusText);
//                     }
//                 } catch (error) {
//                     console.error('Error adding item:', error);
//                 }
//             }
//         }
//     };

//     const handleEdit = (item) => {
//         setInputValue(item.name);
//         setItem1(item.item1 || '');
//         setItem2(item.item2 || '');
//         setItem3(item.item3 || '');
//         setItem4(item.item4 || '');
//         setItem5(item.item5 || '');
//         setEditItemId(item.id);
//         handleShow();
//     };

//     const handleDelete = async (itemId) => {
//         if (window.confirm('Are you sure you want to delete this item?')) {
//             try {
//                 const response = await fetch(`https://taaiappapi.emedha.in/pages/api/api/menuitems/${itemId}`, {
//                     method: 'DELETE',
//                 });
//                 if (response.ok) {
//                     setItems(items.filter(item => item.id !== itemId));
//                 } else {
//                     console.error('Error deleting item:', response.statusText);
//                 }
//             } catch (error) {
//                 console.error('Error deleting item:', error);
//             }
//         }
//     };

//     const totalPages = Math.ceil(items.length / itemsPerPage);
//     const currentItems = items.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

//     return (
//         <div className="container mt-5" style={{ maxWidth: '1200px', margin: 'auto', textAlign: 'left', fontSize: '12px' }}>
//             <h4 style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', border: "1px solid grey", padding: '5px' }}>
//                 <IoArrowBackCircle onClick={onBack} style={{ cursor: 'pointer' }} size={28} />
//                 MENU ITEMS
//                 <button style={{ backgroundColor: '#00a2ffff', color: 'white', border: 'none', padding: '4px 16px', fontSize: '14px', cursor: 'pointer', marginBottom: '10px', }} onClick={handleShow}>+ Add</button>
//             </h4>

//             <Table striped bordered hover responsive>
//                 <thead>
//                     <tr>
//                         <th>#</th>
//                         <th>Item</th>
//                         <th>Sub Menus</th>
//                         <th>Actions</th>
//                     </tr>
//                 </thead>
//                 <tbody>
//                     {currentItems.map((item, index) => (
//                         <tr key={item.id}>
//                             <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
//                             <td>{item.name}</td>
//                             <td>{[item.item1, item.item2, item.item3].filter(Boolean).join(', ')}</td>
//                             <td>
//                                 <button className=" me-2" onClick={() => handleEdit(item)}>Edit</button>
//                                 <button className=" " onClick={() => handleDelete(item.id)}>Delete</button>
//                             </td>
//                         </tr>
//                     ))}
//                 </tbody>
//             </Table>

//             <Modal show={showModal} onHide={handleClose}>
//                 <Modal.Header closeButton><Modal.Title>{editItemId ? 'EDIT MENU ITEM' : 'ADD MENU ITEM'}</Modal.Title></Modal.Header>
//                 <Modal.Body>
//                     <form onSubmit={handleSubmit}>
//                         <div className="mb-3">
//                             <label htmlFor="itemInput" className="form-label">Item Name</label>
//                             <input type="text" className="form-control" id="itemInput" value={inputValue} onChange={e => setInputValue(e.target.value)} required style={{ borderRadius: 0 }} />
//                         </div>
//                         {[1, 2, 3, 4, 5].map(i => (
//                             <div className="mb-3" key={i}>
//                                 <label htmlFor={`item${i}`} className="form-label">Sub Menu {i}</label>
//                                 <input type="text" className="form-control" id={`item${i}`} value={[item1, item2, item3, item4, item5][i - 1]} onChange={e => { const setters = [setItem1, setItem2, setItem3, setItem4, setItem5]; setters[i - 1](e.target.value); }} style={{ borderRadius: 0 }} />
//                             </div>
//                         ))}
//                         <button className="btn btn-primary btn-sm" style={{ borderRadius: 0 }} type="submit">Submit</button>
//                     </form>
//                 </Modal.Body>
//             </Modal>

//             <Pagination className="justify-content-center mt-3">
//                 <Pagination.Prev onClick={() => setCurrentPage(p => Math.max(p - 1, 1))} disabled={currentPage === 1} />
//                 {[...Array(totalPages).keys()].map(page => (
//                     <Pagination.Item key={page + 1} active={page + 1 === currentPage} onClick={() => setCurrentPage(page + 1)}>{page + 1}</Pagination.Item>
//                 ))}
//                 <Pagination.Next onClick={() => setCurrentPage(p => Math.min(p + 1, totalPages))} disabled={currentPage === totalPages} />
//             </Pagination>
//         </div>
//     );
// };

// const Stalls = ({ onBack }) => {
//     const [show, setShow] = useState(false);
//     const [stallsData, setStallsData] = useState([]);
//     const [formData, setFormData] = useState({
//         stallno: '',
//         stallowner: '',
//         email: '',
//         mobile: '',
//         whatsappno: '',
//         type: 'Product'
//     });
//     const [isEditing, setIsEditing] = useState(false);
//     const [editId, setEditId] = useState(null);
//     const [currentPage, setCurrentPage] = useState(1);
//     const entriesPerPage = 10;

//     useEffect(() => {
//         fetchStalls();
//     }, []);

//     const fetchStalls = async () => {
//         try {
//             const response = await axios.get('https://taaiappapi.emedha.in/pages/api/api/stalls');
//             setStallsData(response.data);
//         } catch (error) {
//             console.error('Error fetching stalls:', error);
//         }
//     };
//     const handleClose = () => setShow(false);
//     const handleShow = () => {
//         setShow(true);
//         setIsEditing(false);
//         setFormData({
//             stallno: '',
//             stallowner: '',
//             email: '',
//             mobile: '',
//             whatsappno: '',
//             type: 'Product'
//         });
//     };

//     const handleChange = (e) => {
//         const { name, value } = e.target;
//         setFormData({
//             ...formData,
//             [name]: value
//         });
//     };

//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         try {
//             if (isEditing) {
//                 await axios.put(`https://taaiappapi.emedha.in/pages/api/api/stalls/${editId}`, formData);
//             } else {
//                 await axios.post('https://taaiappapi.emedha.in/pages/api/api/stalls', formData);
//             }
//             fetchStalls();
//             handleClose();
//         } catch (error) {
//             console.error('Error saving data:', error);
//         }
//     };

//     const handleEdit = (stall) => {
//         setFormData({
//             stallno: stall.stallno,
//             stallowner: stall.stallowner,
//             email: stall.email,
//             mobile: stall.mobile,
//             whatsappno: stall.whatsappno,
//             type: stall.type || 'Product'
//         });
//         setEditId(stall.id);
//         setIsEditing(true);
//         setShow(true);
//     };

//     const handleDelete = async (id) => {
//         try {
//             await axios.delete(`https://taaiappapi.emedha.in/pages/api/api/stalls/${id}`);
//             fetchStalls();
//         } catch (error) {
//             console.error('Error deleting stall:', error);
//         }
//     };
//     // Pagination logic
//     const indexOfLastEntry = currentPage * entriesPerPage;
//     const indexOfFirstEntry = indexOfLastEntry - entriesPerPage;
//     const currentEntries = stallsData.slice(indexOfFirstEntry, indexOfLastEntry);
//     const totalPages = Math.ceil(stallsData.length / entriesPerPage);
//     const handlePageChange = (pageNumber) => {
//         setCurrentPage(pageNumber);
//     };

//     return (
//         <>
//             <div className="container mt-5">
//                 <h4 style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', border: "1px solid grey", padding: '5px' }}>
//                     <IoArrowBackCircle onClick={onBack} style={{ cursor: 'pointer' }} size={28} />
//                     STALLS
//                     <button style={{ backgroundColor: '#00a2ffff', color: 'white', border: 'none', padding: '4px 16px', fontSize: '14px', cursor: 'pointer', marginBottom: '10px', }} onClick={handleShow}>+ Add</button>
//                 </h4>

//                 <Modal show={show} onHide={handleClose} size="lg">
//                     <Modal.Header closeButton>
//                         <Modal.Title>{isEditing ? 'EDIT STALL' : 'ADD STALL'}</Modal.Title>
//                     </Modal.Header>
//                     <Modal.Body>
//                         <form onSubmit={handleSubmit}>
//                             <div className="mb-3">
//                                 <label htmlFor="stallno" className="form-label">Stall No</label>
//                                 <input type="text" className="form-control" id="stallno" name="stallno" value={formData.stallno} onChange={handleChange} required style={{ borderRadius: '0px' }} />
//                             </div>
//                             <div className="mb-3">
//                                 <label htmlFor="stallowner" className="form-label">Stall Owner</label>
//                                 <input type="text" className="form-control" id="stallowner" name="stallowner" value={formData.stallowner} onChange={handleChange} required style={{ borderRadius: '0px' }} />
//                             </div>
//                             <div className="mb-3">
//                                 <label htmlFor="type" className="form-label">Type</label>
//                                 <select className="form-control" id="type" name="type" value={formData.type} onChange={handleChange} required style={{ borderRadius: '0px' }}>
//                                     <option value="Product">Product</option>
//                                     <option value="Service">Service</option>
//                                 </select>
//                             </div>
//                             <div className="mb-3">
//                                 <label htmlFor="email" className="form-label">Email</label>
//                                 <input type="email" className="form-control" id="email" name="email" value={formData.email} onChange={handleChange} required style={{ borderRadius: '0px' }} />
//                             </div>
//                             <div className="mb-3">
//                                 <label htmlFor="mobile" className="form-label">Mobile</label>
//                                 <input type="text" className="form-control" id="mobile" name="mobile" value={formData.mobile} onChange={handleChange} required style={{ borderRadius: '0px' }} />
//                             </div>
//                             <div className="mb-3">
//                                 <label htmlFor="whatsappno" className="form-label">WhatsApp No</label>
//                                 <input type="text" className="form-control" id="whatsappno" name="whatsappno" value={formData.whatsappno} onChange={handleChange} required style={{ borderRadius: '0px' }} />
//                             </div>
//                             <button type="submit" className="btn btn-primary btn-sm mt-2">
//                                 {isEditing ? 'Update' : 'Submit'}
//                             </button>
//                         </form>
//                     </Modal.Body>
//                 </Modal>

//                 <div className="table-responsive">
//                     <Table striped bordered hover responsive>
//                         <thead>
//                             <tr>
//                                 <th>Stall No</th>
//                                 <th>Stall Owner</th>
//                                 <th>Type</th>
//                                 <th>Email</th>
//                                 <th>Mobile</th>
//                                 <th>WhatsApp No</th>
//                                 <th>QR Code</th>
//                                 <th>Actions</th>
//                             </tr>
//                         </thead>
//                         <tbody>
//                             {currentEntries.map((stall) => {
//                                 const qrData = { stallno: stall.stallno, stallowner: stall.stallowner, type: stall.type, email: stall.email, mobile: stall.mobile, whatsappno: stall.whatsappno };
//                                 return (
//                                     <tr key={stall.id}>
//                                         <td>{stall.stallno}</td>
//                                         <td>{stall.stallowner}</td>
//                                         <td>{stall.type}</td>
//                                         <td>{stall.email}</td>
//                                         <td>{stall.mobile}</td>
//                                         <td>{stall.whatsappno}</td>
//                                         <td><QRCodeCanvas value={JSON.stringify(qrData)} size={100} /></td>
//                                         <td>
//                                             <button className="btn btn-warning btn-sm me-2" onClick={() => handleEdit(stall)}>Edit</button>
//                                             <button className="btn btn-danger btn-sm" onClick={() => handleDelete(stall.id)}>Delete</button>
//                                         </td>
//                                     </tr>
//                                 );
//                             })}
//                         </tbody>
//                     </Table>
//                 </div>

//                 {/* Pagination Controls */}
//                 <div className="d-flex justify-content-between mt-3">
//                     <button disabled={currentPage === 1} onClick={() => handlePageChange(currentPage - 1)}>Previous</button>
//                     <div>Page {currentPage} of {totalPages}</div>
//                     <button disabled={currentPage === totalPages} onClick={() => handlePageChange(currentPage + 1)}>Next</button>
//                 </div>
//             </div>
//         </>
//     );
// };

// const Helpdesk = ({ onBack }) => {
//     const [show, setShow] = useState(false);
//     const [helpdeskEntries, setHelpdeskEntries] = useState([]);
//     const [formData, setFormData] = useState({ description: '', call: '', whatsapp: '' });
//     const [isEditing, setIsEditing] = useState(false);
//     const [editId, setEditId] = useState(null);

//     // Pagination state
//     const [currentPage, setCurrentPage] = useState(1);
//     const entriesPerPage = 10;

//     useEffect(() => {
//         fetchHelpdeskEntries();
//     }, []);

//     const fetchHelpdeskEntries = async () => {
//         try {
//             const response = await axios.get('https://taaiappapi.emedha.in/pages/api/api/helpdesk');
//             setHelpdeskEntries(response.data);
//         } catch (error) {
//             console.error('Error fetching help desk entries:', error);
//         }
//     };

//     const handleClose = () => {
//         setShow(false);
//         setIsEditing(false);
//         setFormData({ description: '', call: '', whatsapp: '' });
//     };

//     const handleShow = () => setShow(true);

//     const handleChange = (e) => {
//         const { name, value } = e.target;
//         setFormData({ ...formData, [name]: value });
//     };

//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         try {
//             if (isEditing) {
//                 await axios.put(`https://taaiappapi.emedha.in/pages/api/api/helpdesk/${editId}`, formData);
//             } else {
//                 await axios.post('https://taaiappapi.emedha.in/pages/api/api/helpdesk', formData);
//             }
//             fetchHelpdeskEntries(); // Refresh the list
//             handleClose();
//         } catch (error) {
//             console.error('Error saving help desk entry:', error);
//         }
//     };

//     const handleEdit = (entry) => {
//         setFormData(entry);
//         setEditId(entry.id);
//         setIsEditing(true);
//         setShow(true);
//     };

//     const handleDelete = async (id) => {
//         try {
//             await axios.delete(`https://taaiappapi.emedha.in/pages/api/api/helpdesk/${id}`);
//             fetchHelpdeskEntries(); // Refresh the list
//         } catch (error) {
//             console.error('Error deleting help desk entry:', error);
//         }
//     };

//     // Pagination logic
//     const indexOfLastEntry = currentPage * entriesPerPage;
//     const indexOfFirstEntry = indexOfLastEntry - entriesPerPage;
//     const currentEntries = helpdeskEntries.slice(indexOfFirstEntry, indexOfLastEntry);

//     const totalPages = Math.ceil(helpdeskEntries.length / entriesPerPage);

//     const handlePageChange = (pageNumber) => {
//         setCurrentPage(pageNumber);
//     };

//     return (
//         <>
//             <div className="container mt-5" style={{ fontSize: '14px' }}>
//                 <h4 style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', border: "1px solid grey", padding: '5px' }}>
//                     <IoArrowBackCircle onClick={onBack} style={{ cursor: 'pointer' }} size={28} />
//                     HELP DESK
//                     <button style={{ backgroundColor: '#00a2ffff', color: 'white', border: 'none', padding: '4px 16px', fontSize: '14px', cursor: 'pointer', marginBottom: '10px', }} onClick={handleShow}>+ Add</button>
//                 </h4>

//                 <div className={`modal fade ${show ? 'show d-block' : ''}`} tabIndex="-1" role="dialog" style={{ backgroundColor: show ? 'rgba(0,0,0,0.5)' : 'transparent' }}>
//                     <div className="modal-dialog" role="document">
//                         <div className="modal-content">
//                             <div className="modal-header">
//                                 <h5 className="modal-title">{isEditing ? 'Edit Help Desk Entry' : 'Add Help Desk Entry'}</h5>
//                                 <button type="button" className="btn-close" onClick={handleClose}></button>
//                             </div>
//                             <div className="modal-body">
//                                 <form onSubmit={handleSubmit}>
//                                     <div className="mb-3">
//                                         <label htmlFor="formDescription" className="form-label">Description</label>
//                                         <input type="text" className="form-control" id="formDescription" name="description" value={formData.description} onChange={handleChange} required style={{ borderRadius: '0px' }} />
//                                     </div>

//                                     <div className="mb-3">
//                                         <label htmlFor="formCall" className="form-label">Call</label>
//                                         <input type="text" className="form-control" id="formCall" name="call" value={formData.call} onChange={handleChange} required style={{ borderRadius: '0px' }} />
//                                     </div>

//                                     <div className="mb-3">
//                                         <label htmlFor="formWhatsapp" className="form-label">WhatsApp</label>
//                                         <input type="text" className="form-control" id="formWhatsapp" name="whatsapp" value={formData.whatsapp} onChange={handleChange} required style={{ borderRadius: '0px' }} />
//                                     </div>

//                                     <button type="submit" className="btn btn-primary btn-sm mt-2">{isEditing ? 'Update' : 'Submit'}</button>
//                                 </form>
//                             </div>
//                         </div>
//                     </div>
//                 </div>

//                 {/* Table to display help desk entries */}
//                 <div className="table-responsive">
//                     <Table striped bordered hover responsive>
//                         <thead>
//                             <tr>
//                                 <th>Description</th>
//                                 <th>Call</th>
//                                 <th>WhatsApp</th>
//                                 <th>Actions</th>
//                             </tr>
//                         </thead>
//                         <tbody>
//                             {currentEntries.map((entry) => (
//                                 <tr key={entry.id}>
//                                     <td>{entry.description}</td>
//                                     <td>{entry.call}</td>
//                                     <td>{entry.whatsapp}</td>
//                                     <td>
//                                         <button variant="btn btn-warning btn-sm me-2" onClick={() => handleEdit(entry)}>Edit</button>
//                                         <button variant="btn btn-danger btn-sm" onClick={() => handleDelete(entry.id)}>Delete</button>
//                                     </td>
//                                 </tr>
//                             ))}
//                         </tbody>
//                     </Table>
//                 </div>
//                 <div className="d-flex justify-content-between mt-3">
//                     <button disabled={currentPage === 1} onClick={() => handlePageChange(currentPage - 1)}>Previous</button>
//                     <div>Page {currentPage} of {totalPages}</div>
//                     <button disabled={currentPage === totalPages} onClick={() => handlePageChange(currentPage + 1)}>Next</button>
//                 </div>
//             </div>
//         </>
//     );
// };

// const OnlineQuiz = ({ onBack }) => {
//     const [show, setShow] = useState(false);
//     const [pollEntries, setPollEntries] = useState([]);
//     const [formData, setFormData] = useState({ topic: '', question: '' });
//     const [options, setOptions] = useState(['', '', '', '']);
//     const [correctAnswer, setCorrectAnswer] = useState('');
//     const [isEditing, setIsEditing] = useState(false);
//     const [editId, setEditId] = useState(null);
//     const [currentPage, setCurrentPage] = useState(1);
//     const itemsPerPage = 10;

//     useEffect(() => {
//         fetchPollEntries();
//     }, []);

//     const fetchPollEntries = async () => {
//         try {
//             const response = await axios.get('https://taaiappapi.emedha.in/pages/api/api/quiz');
//             console.log('Fetched Poll Entries:', response.data);
//             setPollEntries(response.data);
//         } catch (error) {
//             console.error('Error fetching poll entries:', error);
//         }
//     };

//     const handleClose = () => {
//         setShow(false);
//         setIsEditing(false);
//         setFormData({ topic: '', question: '' });
//         setOptions(['', '', '', '']);
//         setCorrectAnswer('');
//     };

//     const handleShow = () => {
//         setShow(true);
//     };

//     const handleChange = (e) => {
//         const { name, value } = e.target;
//         setFormData({ ...formData, [name]: value });
//     };

//     const handleOptionChange = (index, value) => {
//         const newOptions = [...options];
//         newOptions[index] = value;
//         setOptions(newOptions);
//     };

//     const handleCorrectAnswerChange = (e) => {
//         setCorrectAnswer(e.target.value);
//     };

//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         const dataToSubmit = {
//             ...formData,
//             options: JSON.stringify(options),
//             correctAnswer
//         };

//         try {
//             if (isEditing) {
//                 await axios.put(`https://taaiappapi.emedha.in/pages/api/api/quiz/${editId}`, dataToSubmit);
//             } else {
//                 await axios.post('https://taaiappapi.emedha.in/pages/api/api/quiz', dataToSubmit);
//             }
//             fetchPollEntries();
//             handleClose();
//         } catch (error) {
//             console.error('Error saving poll entry:', error);
//         }
//     };

//     const handleEdit = (entry) => {
//         setFormData({ topic: entry.topic, question: entry.question });

//         try {
//             const parsedOptions = JSON.parse(entry.options);
//             setOptions(parsedOptions);
//         } catch (error) {
//             console.error('Error parsing options:', error, 'Options:', entry.options);
//             setOptions(['', '', '', '']);
//         }

//         setCorrectAnswer(entry.correctAnswer);
//         setEditId(entry.id);
//         setIsEditing(true);
//         setShow(true);
//     };

//     const handleDelete = async (id) => {
//         try {
//             await axios.delete(`https://taaiappapi.emedha.in/pages/api/api/quiz/${id}`);
//             fetchPollEntries();
//         } catch (error) {
//             console.error('Error deleting poll entry:', error);
//         }
//     };

//     // Calculate current entries for pagination
//     const indexOfLastEntry = currentPage * itemsPerPage;
//     const indexOfFirstEntry = indexOfLastEntry - itemsPerPage;
//     const currentEntries = pollEntries.slice(indexOfFirstEntry, indexOfLastEntry);

//     // Calculate total pages
//     const totalPages = Math.ceil(pollEntries.length / itemsPerPage);

//     return (
//         <>
//             <div className="container mt-5" style={{ fontSize: '14px' }}>
//                 <h4 style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', border: "1px solid grey", padding: '5px' }}>
//                     <IoArrowBackCircle onClick={onBack} style={{ cursor: 'pointer' }} size={28} />
//                     ONLINE QUIZ
//                     <button style={{ backgroundColor: '#00a2ffff', color: 'white', border: 'none', padding: '4px 16px', fontSize: '14px', cursor: 'pointer', marginBottom: '10px', }} onClick={handleShow}>+ Add</button>
//                 </h4>

//                 <Modal show={show} onHide={handleClose}>
//                     <Modal.Header closeButton>
//                         <Modal.Title>{isEditing ? 'Edit Poll Entry' : 'Add Poll Entry'}</Modal.Title>
//                     </Modal.Header>
//                     <Modal.Body>
//                         <form onSubmit={handleSubmit}>
//                             <div className="mb-3">
//                                 <label htmlFor="formTopic" className="form-label">Topic</label>
//                                 <input type="text" className="form-control" id="formTopic" name="topic" value={formData.topic} onChange={handleChange} required style={{ borderRadius: '0px' }} />
//                             </div>
//                             <div className="mb-3">
//                                 <label htmlFor="formQuestion" className="form-label">Poll Question</label>
//                                 <input type="text" className="form-control" id="formQuestion" name="question" value={formData.question} onChange={handleChange} required style={{ borderRadius: '0px' }} />
//                             </div>
//                             {options.map((option, index) => (
//                                 <div className="mb-3" key={index}>
//                                     <label htmlFor={`formOption${index}`} className="form-label">Option {index + 1}</label>
//                                     <input type="text" className="form-control" id={`formOption${index}`} value={option} onChange={(e) => handleOptionChange(index, e.target.value)} required style={{ borderRadius: '0px' }} />
//                                 </div>
//                             ))}
//                             <div className="mb-3">
//                                 <label htmlFor="formCorrectAnswer" className="form-label">Correct Answer</label>
//                                 <input type="text" className="form-control" id="formCorrectAnswer" value={correctAnswer} onChange={handleCorrectAnswerChange} required style={{ borderRadius: '0px' }} />
//                             </div>
//                             <button type="submit" className="btn btn-primary btn-sm mt-3">{isEditing ? 'Update' : 'Submit'}</button>
//                         </form>
//                     </Modal.Body>
//                 </Modal>

//                 <div className="table-responsive">
//                     <Table striped bordered hover responsive>
//                         <thead>
//                             <tr>
//                                 <th>#</th>
//                                 <th>Topic</th>
//                                 <th>Poll Question</th>
//                                 <th>Options</th>
//                                 <th>Answer</th>
//                                 <th>Actions</th>
//                             </tr>
//                         </thead>
//                         <tbody>
//                             {currentEntries.map((entry, index) => (
//                                 <tr key={entry.id}>
//                                     <td>{index + 1 + (currentPage - 1) * itemsPerPage}</td>
//                                     <td>{entry.topic}</td>
//                                     <td>{entry.question}</td>
//                                     <td>
//                                         {(() => {
//                                             try {
//                                                 const parsedOptions = JSON.parse(entry.options);
//                                                 if (Array.isArray(parsedOptions)) {
//                                                     return parsedOptions.join(', ');
//                                                 }
//                                             } catch (error) {
//                                                 console.error('Error parsing options:', error);
//                                             }
//                                             return entry.options || 'No options available';
//                                         })()}
//                                     </td>
//                                     <td>{entry.correctAnswer}</td>
//                                     <td>
//                                         <button variant="btn btn-warning btn-sm me-2" onClick={() => handleEdit(entry)}>Edit</button>
//                                         <button variant="btn btn-danger btn-sm" onClick={() => handleDelete(entry.id)}>Delete</button>
//                                     </td>
//                                 </tr>
//                             ))}
//                         </tbody>
//                     </Table>
//                 </div>

//                 {/* Pagination Controls */}
//                 <Pagination className="justify-content-center mt-4">
//                     <Pagination.Prev onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))} disabled={currentPage === 1} />
//                     {[...Array(totalPages).keys()].map(page => (
//                         <Pagination.Item key={page + 1} active={page + 1 === currentPage} onClick={() => setCurrentPage(page + 1)}>{page + 1}</Pagination.Item>
//                     ))}
//                     <Pagination.Next onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))} disabled={currentPage === totalPages} />
//                 </Pagination>
//             </div>
//         </>
//     );
// };

// const Notifications = ({ onBack }) => {
//     const [show, setShow] = useState(false);
//     const [notifications, setNotifications] = useState([]);
//     const [formData, setFormData] = useState({ title: '', description: '' });
//     const [isEditing, setIsEditing] = useState(false);
//     const [editId, setEditId] = useState(null);

//     // Pagination state
//     const [currentPage, setCurrentPage] = useState(1);
//     const entriesPerPage = 10;

//     useEffect(() => {
//         fetchNotifications();
//     }, []);

//     const fetchNotifications = async () => {
//         try {
//             const response = await axios.get('https://taaiappapi.emedha.in/pages/api/api/notifications');
//             setNotifications(response.data);
//         } catch (error) {
//             console.error('Error fetching notifications:', error);
//         }
//     };

//     const handleClose = () => {
//         setShow(false);
//         setIsEditing(false);
//         setFormData({ title: '', description: '' });
//     };

//     const handleShow = () => {
//         setShow(true);
//     };

//     const handleChange = (e) => {
//         const { name, value } = e.target;
//         setFormData({ ...formData, [name]: value });
//     };

//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         try {
//             if (isEditing) {
//                 await axios.put(`https://taaiappapi.emedha.in/pages/api/api/notifications/${editId}`, formData);
//             } else {
//                 await axios.post('https://taaiappapi.emedha.in/pages/api/api/notifications', formData);
//             }
//             fetchNotifications(); // Refresh the notifications list
//             handleClose();
//         } catch (error) {
//             console.error('Error saving notification:', error);
//         }
//     };

//     const handleEdit = (notification) => {
//         setFormData(notification);
//         setEditId(notification.id);
//         setIsEditing(true);
//         setShow(true);
//     };

//     const handleDelete = async (id) => {
//         try {
//             await axios.delete(`https://taaiappapi.emedha.in/pages/api/api/notifications/${id}`);
//             fetchNotifications(); // Refresh the notifications list
//         } catch (error) {
//             console.error('Error deleting notification:', error);
//         }
//     };

//     // Pagination logic
//     const indexOfLastEntry = currentPage * entriesPerPage;
//     const indexOfFirstEntry = indexOfLastEntry - entriesPerPage;
//     const currentEntries = notifications.slice(indexOfFirstEntry, indexOfLastEntry);

//     const totalPages = Math.ceil(notifications.length / entriesPerPage);

//     const handlePageChange = (pageNumber) => {
//         setCurrentPage(pageNumber);
//     };

//     return (
//         <>
//             <div className="container mt-5" style={{ fontSize: '14px' }}>
//                 <h4 style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', border: "1px solid grey", padding: '5px' }}>
//                     <IoArrowBackCircle onClick={onBack} style={{ cursor: 'pointer' }} size={28} />
//                     NOTIFICATION
//                     <button style={{ backgroundColor: '#00a2ffff', color: 'white', border: 'none', padding: '4px 16px', fontSize: '14px', cursor: 'pointer', marginBottom: '10px', }} onClick={handleShow}>+ Add</button>
//                 </h4>

//                 <Modal show={show} onHide={handleClose}>
//                     <Modal.Header closeButton>
//                         <Modal.Title>{isEditing ? 'Edit Notification' : 'Add Notification'}</Modal.Title>
//                     </Modal.Header>
//                     <Modal.Body>
//                         <form onSubmit={handleSubmit}>
//                             <div className="mb-3">
//                                 <label htmlFor="formTitle" className="form-label">Title</label>
//                                 <input type="text" className="form-control" id="formTitle" name="title" value={formData.title} onChange={handleChange} required style={{ borderRadius: '0px' }} />
//                             </div>
//                             <div className="mb-3">
//                                 <label htmlFor="formDescription" className="form-label">Description</label>
//                                 <textarea className="form-control" id="formDescription" name="description" rows="3" value={formData.description} onChange={handleChange} required style={{ borderRadius: '0px' }}></textarea>
//                             </div>
//                             <button type="submit" className="btn btn-primary btn-sm mt-3">{isEditing ? 'Update' : 'Submit'}</button>
//                         </form>
//                     </Modal.Body>
//                 </Modal>

//                 <Table striped bordered hover responsive>
//                     <thead>
//                         <tr>
//                             <th>Title</th>
//                             <th>Description</th>
//                             <th>Actions</th>
//                         </tr>
//                     </thead>
//                     <tbody>
//                         {currentEntries.map((notification) => (
//                             <tr key={notification.id}>
//                                 <td>{notification.title}</td>
//                                 <td>{notification.description}</td>
//                                 <td>
//                                     <button variant="btn btn-warning btn-sm me-2" onClick={() => handleEdit(notification)}>Edit</button>
//                                     <button variant="btn btn-danger btn-sm" onClick={() => handleDelete(notification.id)}>Delete</button>
//                                 </td>
//                             </tr>
//                         ))}
//                     </tbody>
//                 </Table>

//                 {/* Pagination Controls */}
//                 <div className="d-flex justify-content-between mt-3">
//                     <button disabled={currentPage === 1} onClick={() => handlePageChange(currentPage - 1)}>Previous</button>
//                     <div>Page {currentPage} of {totalPages}</div>
//                     <button disabled={currentPage === totalPages} onClick={() => handlePageChange(currentPage + 1)}>Next</button>
//                 </div>
//             </div>
//         </>
//     );
// };

// const EventCalendar = ({ onBack }) => {
//     const [showModal, setShowModal] = useState(false);
//     const [formData, setFormData] = useState({ name: '', description: '', venue: '', schedule: '', date: '' });
//     const [events, setEvents] = useState([]);
//     const [editingId, setEditingId] = useState(null);
//     const [currentPage, setCurrentPage] = useState(1);
//     const itemsPerPage = 10;

//     useEffect(() => {
//         fetchEvents();
//     }, []);

//     const fetchEvents = async () => {
//         try {
//             const response = await fetch('https://taaiappapi.emedha.in/pages/api/api/events');
//             const data = await response.json();

//             console.log(data)
//             if (Array.isArray(data)) {
//                 const groupedEvents = data.reduce((acc, event) => {
//                     const eventDate = new Date(event.date).toLocaleDateString();
//                     if (!acc[eventDate]) acc[eventDate] = [];
//                     acc[eventDate].push(event);
//                     return acc;
//                 }, {});

//                 const sortedDates = Object.keys(groupedEvents).sort((a, b) => new Date(a) - new Date(b));

//                 const sortedEvents = {};
//                 sortedDates.forEach(date => {
//                     sortedEvents[date] = groupedEvents[date];
//                 });

//                 setEvents(sortedEvents);

//             } else {
//                 console.error('Expected an array but received:', data);
//                 setEvents({});
//             }
//         } catch (error) {
//             console.error('Error fetching events:', error);
//             setEvents({});
//         }
//     };

//     const handleShow = (event = null) => {
//         if (event) {
//             setFormData({
//                 name: event.name,
//                 description: event.description,
//                 venue: event.venue,
//                 schedule: event.schedule,
//                 date: event.date,
//             });
//             setEditingId(event.id);
//         } else {
//             setFormData({ name: '', venue: '', schedule: '', date: '' });
//             setEditingId(null);
//         }
//         setShowModal(true);
//     };


//     const handleClose = () => setShowModal(false);

//     const handleInputChange = (e) => {
//         const { name, value } = e.target;
//         setFormData({ ...formData, [name]: value });
//     };


//     const handleSubmit = async (e) => {
//         e.preventDefault();

//         const method = editingId ? 'PUT' : 'POST';
//         const url = editingId
//             ? `https://taaiappapi.emedha.in/pages/api/api/events/${editingId}`
//             : 'https://taaiappapi.emedha.in/pages/api/api/events';

//         const eventData = {};
//         if (formData.name) eventData.name = formData.name;
//         if (formData.description) eventData.description = formData.description;
//         if (formData.venue) eventData.venue = formData.venue;
//         if (formData.schedule) eventData.schedule = formData.schedule;
//         if (formData.date) eventData.date = formData.date;

//         try {
//             const response = await fetch(url, {
//                 method,
//                 headers: {
//                     'Content-Type': 'application/json',
//                 },
//                 body: JSON.stringify(eventData),
//             });

//             if (response.ok) {
//                 fetchEvents();
//                 handleClose();
//             } else {
//                 console.error('Error submitting event:', response.statusText);
//             }
//         } catch (error) {
//             console.error('Error submitting event:', error);
//         }
//     };


//     const handleDelete = async (eventId) => {
//         if (window.confirm('Are you sure you want to delete this event?')) {
//             const response = await fetch(`https://taaiappapi.emedha.in/pages/api/api/events/${eventId}`, {
//                 method: 'DELETE',
//             });
//             if (response.ok) {
//                 fetchEvents(); // Refresh events list
//             } else {
//                 console.error('Error deleting event:', response.statusText);
//             }
//         }
//     };


//     // Pagination logic for dates (not events directly)
//     const totalPages = Math.ceil(Object.keys(events).length / itemsPerPage);
//     const currentDates = Object.keys(events).slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

//     return (
//         <>
//             <div className="container mt-5" style={{ fontSize: '14px' }}>
//                 <h4 style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', border: "1px solid grey", padding: '5px' }}>
//                     <IoArrowBackCircle onClick={onBack} style={{ cursor: 'pointer' }} size={28} />
//                     EVENT CALENDER
//                     <button style={{ backgroundColor: '#00a2ffff', color: 'white', border: 'none', padding: '4px 16px', fontSize: '14px', cursor: 'pointer', marginBottom: '10px', }} onClick={handleShow}>+ Add</button>
//                 </h4>

//                 <Table striped bordered hover responsive="sm">
//                     <thead>
//                         <tr>
//                             <th>#</th>
//                             <th>Schedule</th>
//                             <th>Particulars</th>
//                             <th>Remarks</th>
//                             <th>Venue  </th>
//                             <th>Actions</th>
//                         </tr>
//                     </thead>
//                     <tbody>
//                         {currentDates.map((date, index) => (
//                             <React.Fragment key={date}>
//                                 <tr>
//                                     <td colSpan="7" style={{ textAlign: 'center', fontWeight: 'bold' }}>
//                                         {new Date(date).toLocaleDateString('en-US', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}
//                                     </td>
//                                 </tr>
//                                 {Array.isArray(events[date]) && events[date].map((event, eventIndex) => (
//                                     <tr key={event.id}>
//                                         <td>{(currentPage - 1) * itemsPerPage + index + eventIndex + 1}</td>
//                                         <td>{event.schedule}</td>
//                                         <td>{event.name}</td>
//                                         <td>{event.description || ''}</td>
//                                         <td>{event.venue || ''}</td>
//                                         <td>
//                                             <FaEdit className='me-3' style={{ cursor: 'pointer' }} onClick={() => handleShow(event)} />
//                                             <MdDelete style={{ cursor: 'pointer' }} onClick={() => handleDelete(event.id)} />
//                                         </td>
//                                     </tr>
//                                 ))}
//                             </React.Fragment>
//                         ))}
//                     </tbody>
//                 </Table>

//                 {/* Modal for Adding/Editing Events */}
//                 <Modal show={showModal} onHide={handleClose} size="lg">
//                     <Modal.Header closeButton>
//                         <Modal.Title>{editingId ? 'Edit Event' : 'Add Event'}</Modal.Title>
//                     </Modal.Header>
//                     <Modal.Body>
//                         <form onSubmit={handleSubmit}>
//                             <div className="mb-3">
//                                 <label htmlFor="schedule" className="form-label">Schedule Time</label>
//                                 <input type="text" className="form-control" id="schedule" name="schedule" value={formData.schedule} onChange={handleInputChange} style={{ borderRadius: "0px" }} />
//                             </div>
//                             <div className="mb-3">
//                                 <label htmlFor="name" className="form-label">Particulars</label>
//                                 <input type="text" className="form-control" id="name" name="name" value={formData.name} onChange={handleInputChange} style={{ borderRadius: "0px" }} />
//                             </div>
//                             <div className="mb-3">
//                                 <label htmlFor="description" className="form-label">Remarks</label>
//                                 <input type="text" className="form-control" id="description" name="description" value={formData.description} onChange={handleInputChange} style={{ borderRadius: "0px" }} />
//                             </div>
//                             <div className="mb-3">
//                                 <label htmlFor="venue" className="form-label">Venue</label>
//                                 <input type="text" className="form-control" id="venue" name="venue" value={formData.venue} onChange={handleInputChange} style={{ borderRadius: "0px" }} />
//                             </div>
//                             <div className="mb-3">
//                                 <label htmlFor="date" className="form-label">Date</label>
//                                 <input type="date" className="form-control" id="date" name="date" value={formData.date} onChange={handleInputChange} min={new Date().toISOString().split("T")[0]} style={{ borderRadius: "0px" }} />
//                             </div>
//                             <button className="btn btn-primary btn-sm" type="submit">Submit</button>
//                         </form>
//                     </Modal.Body>
//                 </Modal>

//                 {/* Pagination Controls */}
//                 <Pagination className="justify-content-center mt-4">
//                     <Pagination.Prev onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))} disabled={currentPage === 1} />
//                     {[...Array(totalPages).keys()].map(page => (
//                         <Pagination.Item key={page + 1} active={page + 1 === currentPage} onClick={() => setCurrentPage(page + 1)}>
//                             {page + 1}
//                         </Pagination.Item>
//                     ))}
//                     <Pagination.Next onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))} disabled={currentPage === totalPages} />
//                 </Pagination>
//             </div>
//         </>
//     );
// };

// const Speakers = ({ onBack }) => {
//     const [showModal, setShowModal] = useState(false);
//     const [formData, setFormData] = useState({ name: '', title: '', image: null });
//     const [speakers, setSpeakers] = useState([]);
//     const [editIndex, setEditIndex] = useState(null);
//     const [currentPage, setCurrentPage] = useState(1);
//     const itemsPerPage = 10;

//     useEffect(() => {
//         const fetchSpeakers = async () => {
//             try {
//                 const response = await axios.get('https://taaiappapi.emedha.in/pages/api/api/speakers');
//                 setSpeakers(response.data);
//             } catch (error) {
//                 console.error('Error fetching speakers:', error);
//             }
//         };
//         fetchSpeakers();
//     }, []);

//     const handleShow = (index = null) => {
//         if (index !== null && speakers[index]) {
//             setFormData({
//                 name: speakers[index].name,
//                 title: speakers[index].title,
//                 image: null,
//             });
//             setEditIndex(index);
//         } else {
//             setFormData({ name: '', title: '', image: null });
//             setEditIndex(null);
//         }
//         setShowModal(true);
//     };

//     const handleClose = () => setShowModal(false);

//     const handleInputChange = (e) => {
//         const { name, value, files } = e.target;
//         if (name === 'image') {
//             setFormData({ ...formData, image: files[0] });
//         } else {
//             setFormData({ ...formData, [name]: value });
//         }
//     };


//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         console.log("Submitting form...");
//         const { name, title, image } = formData;
//         const formDataToSend = new FormData();
//         formDataToSend.append('name', name);
//         formDataToSend.append('title', title);
//         if (image) {
//             formDataToSend.append('image', image);
//         }
//         try {
//             if (editIndex !== null && speakers[editIndex]) {
//                 await axios.put(`https://taaiappapi.emedha.in/pages/api/api/speakers/${speakers[editIndex].id}`, formDataToSend);
//             } else {
//                 const response = await axios.post('https://taaiappapi.emedha.in/pages/api/api/speakers', formDataToSend);
//                 setSpeakers([...speakers, response.data]);
//             }
//             setFormData({ name: '', title: '', image: '' });
//             handleClose();
//         } catch (error) {
//             console.error('Error saving speaker:', error);
//         }
//     };

//     const handleDelete = async (index) => {
//         const speakerToDelete = speakers[index];
//         if (window.confirm(`Are you sure you want to delete ${speakerToDelete.name}?`)) {
//             try {
//                 await axios.delete(`https://taaiappapi.emedha.in/pages/api/api/speakers/${speakerToDelete.id}`);
//                 const newSpeakers = speakers.filter((_, i) => i !== index);
//                 setSpeakers(newSpeakers);
//             } catch (error) {
//                 console.error('Error deleting speaker:', error);
//             }
//         }
//     };
//     // Pagination Logic
//     const totalPages = Math.ceil(speakers.length / itemsPerPage);
//     const currentSpeakers = speakers.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

//     return (
//         <>
//             <div className="container mt-5">
//                 <h4 style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', border: "1px solid grey", padding: '5px' }}>
//                     <IoArrowBackCircle onClick={onBack} style={{ cursor: 'pointer' }} size={28} />
//                     SPEAKERS & SESSIONS
//                     <button style={{ backgroundColor: '#00a2ffff', color: 'white', border: 'none', padding: '4px 16px', fontSize: '14px', cursor: 'pointer', marginBottom: '10px', }} onClick={handleShow}>+ Add</button>
//                 </h4>
//                 <div className="table-responsive">
//                     <table className="table table-bordered table-striped">
//                         <thead className="table-primary">
//                             <tr>
//                                 <th>#</th>
//                                 <th>Name Of The Speaker</th>
//                                 <th>Title</th>
//                                 <th>Image</th>
//                                 {/* <th>QR Code</th> */}
//                                 <th>Actions</th>
//                             </tr>
//                         </thead>
//                         <tbody>
//                             {currentSpeakers.map((speaker, index) => {
//                                 const titleParts = speaker.title.split('\r\n');
//                                 const eventDateString = titleParts.find(part => /\d{1,2}-\d{1,2}-\d{4}/.test(part));
//                                 const speakerData = { name: speaker.name, title: speaker.title, imageUrl: speaker.imageUrl, eventDate: eventDateString, };
//                                 return (
//                                     <tr key={speaker.id}>
//                                         <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
//                                         <td>{speaker.name}</td>
//                                         <td>{speaker.title}</td>
//                                         <td><img src={speaker.imageUrl} alt={speaker.name} style={{ width: '100px' }} /></td>
//                                         {/* <td><QRCodeCanvas value={JSON.stringify(speakerData)} size={128} /></td> */}
//                                         <td>
//                                             <FaEdit className='me-3' style={{ cursor: 'pointer' }} onClick={() => handleShow((currentPage - 1) * itemsPerPage + index)} />
//                                             <MdDelete style={{ cursor: 'pointer' }} onClick={() => handleDelete((currentPage - 1) * itemsPerPage + index)} />
//                                         </td>
//                                     </tr>
//                                 );
//                             })}
//                         </tbody>
//                     </table>
//                 </div>

//                 <Modal show={showModal} onHide={handleClose} size="lg">
//                     <Modal.Header closeButton><Modal.Title>{editIndex !== null ? 'EDIT SPEAKER' : 'ADD SPEAKER'}</Modal.Title></Modal.Header>
//                     <Modal.Body>
//                         <form onSubmit={handleSubmit}>
//                             <div className="mb-3">
//                                 <label htmlFor="name" className="form-label">Name Of The Speaker</label>
//                                 <input type="text" className="form-control" id="name" name="name" value={formData.name} onChange={handleInputChange} style={{ borderRadius: "0px" }} />
//                             </div>
//                             <div className="mb-3">
//                                 <label htmlFor="title" className="form-label">Title</label>
//                                 <textarea className="form-control" id="title" name="title" value={formData.title} onChange={handleInputChange} style={{ borderRadius: "0px" }} />
//                             </div>
//                             <div className="mb-3">
//                                 <label htmlFor="image" className="form-label">Upload Image</label>
//                                 <input type="file" className="form-control" id="image" name="image" accept="image/*" onChange={handleInputChange} style={{ borderRadius: "0px" }} />
//                             </div>
//                             <button className="btn btn-primary btn-sm" type="submit">Submit</button>
//                         </form>
//                     </Modal.Body>
//                 </Modal>

//                 <Pagination className="justify-content-center mt-4">
//                     <Pagination.Prev onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))} disabled={currentPage === 1} />
//                     {[...Array(totalPages).keys()].map(page => (
//                         <Pagination.Item key={page + 1} active={page + 1 === currentPage} onClick={() => setCurrentPage(page + 1)}>
//                             {page + 1}
//                         </Pagination.Item>
//                     ))}
//                     <Pagination.Next onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))} disabled={currentPage === totalPages} />
//                 </Pagination>
//             </div>
//         </>
//     );
// };

// const Dashboard = () => {
//     const [activeSection, setActiveSection] = useState(null);
//     const [dropdownVisible, setDropdownVisible] = useState(false);
//     const navigate = useNavigate();
//     const handleLogout = () => {
//         localStorage.removeItem('userData');
//         sessionStorage.removeItem('userType');
//         navigate('/');
//         console.log('Logging out...');
//         setDropdownVisible(false);
//     };
//     const toggleDropdown = () => {
//         setDropdownVisible(!dropdownVisible);
//     };
//     return (
//         <div style={{ fontFamily: 'Arial, sans-serif', textAlign: 'center', }}>

//             <div style={{ backgroundColor: '#ece8e8ff', display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '10px 30px', }}>
//                 <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', maxWidth: '1200px', margin: '0 auto' }}>
//                     <img src={logo} alt="Logo" style={{ width: '200px', height: '60px', borderRadius: "20px" }} />
//                     <h1 style={{ flexGrow: 1, textAlign: 'center', color: '#2c318d', fontSize: '28px', fontWeight: 'bold', }}>ADMIN DASHBOARD</h1>
//                     <>
//                         <FaUserCircle style={{ fontSize: '32px', color: 'black', cursor: 'pointer', }} onClick={toggleDropdown} />
//                         {dropdownVisible && (
//                             <div style={{ position: 'absolute', right: '30px', top: '70px', backgroundColor: '#fff', zIndex: 1000, boxShadow: '0 4px 12px rgba(0,0,0,0.15)', minWidth: '160px', animation: 'fadeIn 0.3s ease-in-out' }}>
//                                 <div style={{ padding: '10px', display: 'flex', flexDirection: 'column', }}>
//                                     <button onClick={handleLogout} style={{ backgroundColor: '#e53935', color: '#fff', border: 'none', padding: '10px', fontSize: '14px', cursor: 'pointer', transition: 'background 0.3s ease', display: 'flex', alignItems: 'center', gap: '8px' }} onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#c62828'} onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#e53935'}><FaSignOutAlt />Logout</button>
//                                 </div>
//                             </div>
//                         )}
//                     </>
//                 </div>
//             </div>

//             <hr></hr>

//             {!activeSection && (
//                 <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: '20px', padding: '40px', maxWidth: '1000px', margin: 'auto', }}>
//                     {sections.map((section, index) => (
//                         <button key={index} style={{ backgroundColor: '#8d2c2cff', color: 'white', border: 'none', padding: '10px', fontSize: '14px', cursor: 'pointer', transition: 'background-color 0.3s ease', }} onMouseOver={e => (e.target.style.backgroundColor = '#1e2465')} onMouseOut={e => (e.target.style.backgroundColor = '#2c318d')} onClick={() => setActiveSection(section)}>
//                             {section}
//                         </button>
//                     ))}
//                 </div>
//             )}

//             {activeSection === "Menu Items" && <MenuItems onBack={() => setActiveSection(null)} />}
//             {activeSection === "Stalls" && <Stalls onBack={() => setActiveSection(null)} />}
//             {activeSection === "Help Desk" && <Helpdesk onBack={() => setActiveSection(null)} />}
//             {activeSection === "Online Quiz" && <OnlineQuiz onBack={() => setActiveSection(null)} />}
//             {activeSection === "Notifications" && <Notifications onBack={() => setActiveSection(null)} />}
//             {activeSection === "Event Calendar" && <EventCalendar onBack={() => setActiveSection(null)} />}
//             {activeSection === "Speakers & Sessions" && <Speakers onBack={() => setActiveSection(null)} />}

//             {activeSection && activeSection !== "Menu Items" && activeSection !== "Stalls" && activeSection !== "Help Desk" && activeSection !== "Online Quiz" &&
//                 activeSection !== "Notifications" && activeSection !== "Event Calendar" && activeSection !== "Speakers & Sessions" && (
//                     <div style={{ padding: '20px', marginTop: '20px', border: '1px solid #ccc', maxWidth: '1200px', margin: '20px auto', textAlign: 'left', backgroundColor: '#f9f9f9', }}>
//                         <button style={{ backgroundColor: '#999', color: 'white', border: 'none', padding: '8px 16px', fontSize: '14px', cursor: 'pointer', marginBottom: '10px', }} onClick={() => setActiveSection(null)}>← Back</button>
//                         <h2>{activeSection}</h2>
//                         <p>{sectionData[activeSection] || "Content coming soon."}</p>
//                     </div>
//                 )}
//         </div>
//     );
// };

// export default Dashboard;


import React, { useState, useEffect } from 'react';
import { FaEdit, FaSignOutAlt, FaUserCircle } from 'react-icons/fa';
import { IoArrowBackCircle } from 'react-icons/io5';
import { Table, Modal, Pagination } from 'react-bootstrap';
import logo from '../Images/Business_logo.png'
import { MdDelete } from "react-icons/md";
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { QRCodeCanvas } from 'qrcode.react';

import { Button, Form } from 'react-bootstrap';


import { FaShirtsinbulk } from 'react-icons/fa';
import { CiSearch } from "react-icons/ci";
// ADD THESE IMPORTS
import jsPDF from "jspdf";
import QRCode from "qrcode";



const sections = [
    "Menu Items", "Event Calendar", "Speakers & Sessions", "Networking",
    "Stalls", "Online Quiz", "Notifications", "Help Desk",
    "Gallery", "Download", "Register", "Taai Membership", "Attendance", "StallScans", "BizSession", "Sliders"
];

const sectionData = {
    "Event Calendar": "Manage and view all scheduled events in the calendar.",
    "Networking": "Connect attendees and manage networking options.",
    "Online Poll": "Create polls and monitor voting results.",

};

const MenuItems = ({ onBack }) => {
    const [showModal, setShowModal] = useState(false);
    const [inputValue, setInputValue] = useState('');
    const [item1, setItem1] = useState('');
    const [item2, setItem2] = useState('');
    const [item3, setItem3] = useState('');
    const [item4, setItem4] = useState('');
    const [item5, setItem5] = useState('');
    const [items, setItems] = useState([]);
    const [editItemId, setEditItemId] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;

    const handleShow = () => setShowModal(true);
    const handleClose = () => {
        setShowModal(false);
        setInputValue('');
        setItem1('');
        setItem2('');
        setItem3('');
        setItem4('');
        setItem5('');
        setEditItemId(null);
    };

    const fetchItems = async () => {
        try {
            const response = await fetch('https://taaiappapi.emedha.in/pages/api/menuitems');
            const data = await response.json();
            setItems(data);
        } catch (error) {
            console.error('Error fetching items:', error);
        }
    };

    useEffect(() => {
        fetchItems();
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (inputValue) {
            const itemData = { name: inputValue, item1, item2, item3, item4, item5 };
            if (editItemId) {
                try {
                    const response = await fetch(`https://taaiappapi.emedha.in/pages/api/api/menuitems/${editItemId}`, {
                        method: 'PUT',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify(itemData),
                    });
                    if (response.ok) {
                        const updatedItem = await response.json();
                        setItems(items.map(item => (item.id === editItemId ? updatedItem : item)));
                        handleClose();
                    } else {
                        console.error('Error updating item:', response.statusText);
                    }
                } catch (error) {
                    console.error('Error updating item:', error);
                }
            } else {
                try {
                    const response = await fetch('https://taaiappapi.emedha.in/pages/api/menuitems', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify(itemData),
                    });
                    if (response.ok) {
                        const newItem = await response.json();
                        setItems([...items, newItem]);
                        handleClose();
                    } else {
                        console.error('Error adding item:', response.statusText);
                    }
                } catch (error) {
                    console.error('Error adding item:', error);
                }
            }
        }
    };

    const handleEdit = (item) => {
        setInputValue(item.name);
        setItem1(item.item1 || '');
        setItem2(item.item2 || '');
        setItem3(item.item3 || '');
        setItem4(item.item4 || '');
        setItem5(item.item5 || '');
        setEditItemId(item.id);
        handleShow();
    };

    const handleDelete = async (itemId) => {
        if (window.confirm('Are you sure you want to delete this item?')) {
            try {
                const response = await fetch(`https://taaiappapi.emedha.in/pages/api/api/menuitems/${itemId}`, {
                    method: 'DELETE',
                });
                if (response.ok) {
                    setItems(items.filter(item => item.id !== itemId));
                } else {
                    console.error('Error deleting item:', response.statusText);
                }
            } catch (error) {
                console.error('Error deleting item:', error);
            }
        }
    };

    const totalPages = Math.ceil(items.length / itemsPerPage);
    const currentItems = items.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

    return (
        <div className="container mt-5" style={{ maxWidth: '1200px', margin: 'auto', textAlign: 'left', fontSize: '12px' }}>
            <h4 style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', border: "1px solid grey", padding: '5px' }}>
                <IoArrowBackCircle onClick={onBack} style={{ cursor: 'pointer' }} size={28} />
                MENU ITEMS
                <button style={{ backgroundColor: '#00a2ffff', color: 'white', border: 'none', padding: '4px 16px', fontSize: '14px', cursor: 'pointer', marginBottom: '10px', }} onClick={handleShow}>+ Add</button>
            </h4>

            <Table striped bordered hover responsive>
                <thead>
                    <tr>
                        <th>#</th>
                        <th>Item</th>
                        <th>Sub Menus</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {currentItems.map((item, index) => (
                        <tr key={item.id}>
                            <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                            <td>{item.name}</td>
                            <td>{[item.item1, item.item2, item.item3].filter(Boolean).join(', ')}</td>
                            <td>
                                <button className=" me-2" onClick={() => handleEdit(item)}>Edit</button>
                                <button className=" " onClick={() => handleDelete(item.id)}>Delete</button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>

            <Modal show={showModal} onHide={handleClose}>
                <Modal.Header closeButton><Modal.Title>{editItemId ? 'EDIT MENU ITEM' : 'ADD MENU ITEM'}</Modal.Title></Modal.Header>
                <Modal.Body>
                    <form onSubmit={handleSubmit}>
                        <div className="mb-3">
                            <label htmlFor="itemInput" className="form-label">Item Name</label>
                            <input type="text" className="form-control" id="itemInput" value={inputValue} onChange={e => setInputValue(e.target.value)} required style={{ borderRadius: 0 }} />
                        </div>
                        {[1, 2, 3, 4, 5].map(i => (
                            <div className="mb-3" key={i}>
                                <label htmlFor={`item${i}`} className="form-label">Sub Menu {i}</label>
                                <input type="text" className="form-control" id={`item${i}`} value={[item1, item2, item3, item4, item5][i - 1]} onChange={e => { const setters = [setItem1, setItem2, setItem3, setItem4, setItem5]; setters[i - 1](e.target.value); }} style={{ borderRadius: 0 }} />
                            </div>
                        ))}
                        <button className="btn btn-primary btn-sm" style={{ borderRadius: 0 }} type="submit">Submit</button>
                    </form>
                </Modal.Body>
            </Modal>

            <Pagination className="justify-content-center mt-3">
                <Pagination.Prev onClick={() => setCurrentPage(p => Math.max(p - 1, 1))} disabled={currentPage === 1} />
                {[...Array(totalPages).keys()].map(page => (
                    <Pagination.Item key={page + 1} active={page + 1 === currentPage} onClick={() => setCurrentPage(page + 1)}>{page + 1}</Pagination.Item>
                ))}
                <Pagination.Next onClick={() => setCurrentPage(p => Math.min(p + 1, totalPages))} disabled={currentPage === totalPages} />
            </Pagination>
        </div>
    );
};


const Stalls = ({ onBack }) => {
    const [show, setShow] = useState(false);
    const [stallsData, setStallsData] = useState([]);
    const [formData, setFormData] = useState({
        stallno: '',
        stallowner: '',
        email: '',
        mobile: '',
        whatsappno: '',
        type: 'Product'
    });
    const [isEditing, setIsEditing] = useState(false);
    const [editId, setEditId] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const entriesPerPage = 10;

    useEffect(() => {
        fetchStalls();
    }, []);

    const fetchStalls = async () => {
        try {
            const response = await axios.get('https://taaiappapi.emedha.in/pages/api/api/stalls');
            setStallsData(response.data);
        } catch (error) {
            console.error('Error fetching stalls:', error);
        }
    };
    const handleClose = () => setShow(false);
    const handleShow = () => {
        setShow(true);
        setIsEditing(false);
        setFormData({
            stallno: '',
            stallowner: '',
            email: '',
            mobile: '',
            whatsappno: '',
            type: 'Product'
        });
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            if (isEditing) {
                await axios.put(`https://taaiappapi.emedha.in/pages/api/api/stalls/${editId}`, formData);
            } else {
                await axios.post('https://taaiappapi.emedha.in/pages/api/api/stalls', formData);
            }
            fetchStalls();
            handleClose();
        } catch (error) {
            console.error('Error saving data:', error);
        }
    };

    const handleEdit = (stall) => {
        setFormData({
            stallno: stall.stallno,
            stallowner: stall.stallowner,
            email: stall.email,
            mobile: stall.mobile,
            whatsappno: stall.whatsappno,
            type: stall.type || 'Product'
        });
        setEditId(stall.id);
        setIsEditing(true);
        setShow(true);
    };

    const handleDelete = async (id) => {
        try {
            await axios.delete(`https://taaiappapi.emedha.in/pages/api/api/stalls/${id}`);
            fetchStalls();
        } catch (error) {
            console.error('Error deleting stall:', error);
        }
    };
    // Pagination logic
    const indexOfLastEntry = currentPage * entriesPerPage;
    const indexOfFirstEntry = indexOfLastEntry - entriesPerPage;
    const currentEntries = stallsData.slice(indexOfFirstEntry, indexOfLastEntry);
    const totalPages = Math.ceil(stallsData.length / entriesPerPage);
    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    const handleDownloadAllPDF = async () => {
        try {
            const response = await axios.get('https://taaiappapi.emedha.in/pages/api/api/stalls');
            const data = response.data;

            const pdf = new jsPDF();
            const pageHeight = pdf.internal.pageSize.height;
            let y = 20;

            for (let i = 0; i < data.length; i++) {
                const stall = data[i];

                // ✅ Include full stall info in QR
                const qrValue = JSON.stringify({
                    stallno: stall.stallno,
                    stallowner: stall.stallowner,
                    email: stall.email,
                    mobile: stall.mobile,
                    whatsappno: stall.whatsappno,
                    type: stall.type
                });

                const qrCodeDataUrl = await QRCode.toDataURL(qrValue);

                // Stall No and Owner only shown in PDF
                pdf.setFontSize(14);
                pdf.text(`Stall No: ${stall.stallno}`, 10, y);

                const ownerLines = pdf.splitTextToSize(`Owner: ${stall.stallowner}`, 130);
                pdf.text(ownerLines, 10, y + 10);

                pdf.addImage(qrCodeDataUrl, 'PNG', 150, y - 5, 40, 40);

                y += Math.max(ownerLines.length * 10, 60);

                if (y > pageHeight - 40) {
                    pdf.addPage();
                    y = 20;
                }
            }

            pdf.save("All_Stalls.pdf");
        } catch (error) {
            console.error("Error generating PDF:", error);
        }
    };




    return (
        <>
            <div className="container mt-5">
                <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '10px' }}>
                    <button
                        className="btn btn-dark btn-sm"
                        onClick={handleDownloadAllPDF}
                        style={{ borderRadius: '0px' }}
                    >
                        Download All Stalls PDF
                    </button>
                </div>

                <h4 className='mt-4' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', border: "1px solid grey", padding: '5px' }}>
                    <IoArrowBackCircle onClick={onBack} style={{ cursor: 'pointer' }} size={28} />
                    STALLS
                    <button style={{ backgroundColor: '#00a2ffff', color: 'white', border: 'none', padding: '4px 16px', fontSize: '14px', cursor: 'pointer', marginBottom: '10px', }} onClick={handleShow}>+ Add</button>
                </h4>

                <Modal show={show} onHide={handleClose} size="lg">
                    <Modal.Header closeButton>
                        <Modal.Title>{isEditing ? 'EDIT STALL' : 'ADD STALL'}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <form onSubmit={handleSubmit}>
                            <div className="mb-3">
                                <label htmlFor="stallno" className="form-label">Stall No</label>
                                <input type="text" className="form-control" id="stallno" name="stallno" value={formData.stallno} onChange={handleChange} required style={{ borderRadius: '0px' }} />
                            </div>
                            <div className="mb-3">
                                <label htmlFor="stallowner" className="form-label">Stall Owner</label>
                                <input type="text" className="form-control" id="stallowner" name="stallowner" value={formData.stallowner} onChange={handleChange} required style={{ borderRadius: '0px' }} />
                            </div>
                            <div className="mb-3">
                                <label htmlFor="type" className="form-label">Type</label>
                                <select className="form-control" id="type" name="type" value={formData.type} onChange={handleChange} required style={{ borderRadius: '0px' }}>
                                    <option value="Product">Product</option>
                                    <option value="Service">Service</option>
                                </select>
                            </div>
                            <div className="mb-3">
                                <label htmlFor="email" className="form-label">Email</label>
                                <input type="email" className="form-control" id="email" name="email" value={formData.email} onChange={handleChange} required style={{ borderRadius: '0px' }} />
                            </div>
                            <div className="mb-3">
                                <label htmlFor="mobile" className="form-label">Mobile</label>
                                <input type="text" className="form-control" id="mobile" name="mobile" value={formData.mobile} onChange={handleChange} required style={{ borderRadius: '0px' }} />
                            </div>
                            <div className="mb-3">
                                <label htmlFor="whatsappno" className="form-label">WhatsApp No</label>
                                <input type="text" className="form-control" id="whatsappno" name="whatsappno" value={formData.whatsappno} onChange={handleChange} required style={{ borderRadius: '0px' }} />
                            </div>
                            <button type="submit" className="btn btn-primary btn-sm mt-2">
                                {isEditing ? 'Update' : 'Submit'}
                            </button>
                        </form>
                    </Modal.Body>
                </Modal>

                <div className="table-responsive">
                    <Table striped bordered hover responsive>
                        <thead>
                            <tr>
                                <th>Stall No</th>
                                <th>Stall Owner</th>
                                <th>Type</th>
                                <th>Email</th>
                                <th>Mobile</th>
                                <th>WhatsApp No</th>
                                <th>QR Code</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentEntries.map((stall) => {
                                const qrData = { stallno: stall.stallno, stallowner: stall.stallowner, type: stall.type, email: stall.email, mobile: stall.mobile, whatsappno: stall.whatsappno };
                                return (
                                    <tr key={stall.id}>
                                        <td>{stall.stallno}</td>
                                        <td>{stall.stallowner}</td>
                                        <td>{stall.type}</td>
                                        <td>{stall.email}</td>
                                        <td>{stall.mobile}</td>
                                        <td>{stall.whatsappno}</td>
                                        <td><QRCodeCanvas value={JSON.stringify(qrData)} size={100} /></td>
                                        <td>
                                            <button className="btn btn-warning btn-sm me-2" onClick={() => handleEdit(stall)}>Edit</button>
                                            <button className="btn btn-danger btn-sm" onClick={() => handleDelete(stall.id)}>Delete</button>
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </Table>
                </div>

                {/* Pagination Controls */}
                <div className="d-flex justify-content-between mt-3">
                    <button disabled={currentPage === 1} onClick={() => handlePageChange(currentPage - 1)}>Previous</button>
                    <div>Page {currentPage} of {totalPages}</div>
                    <button disabled={currentPage === totalPages} onClick={() => handlePageChange(currentPage + 1)}>Next</button>
                </div>
            </div>
        </>
    );
};

const Helpdesk = ({ onBack }) => {
    const [show, setShow] = useState(false);
    const [helpdeskEntries, setHelpdeskEntries] = useState([]);
    const [formData, setFormData] = useState({ description: '', call: '', whatsapp: '' });
    const [isEditing, setIsEditing] = useState(false);
    const [editId, setEditId] = useState(null);

    // Pagination state
    const [currentPage, setCurrentPage] = useState(1);
    const entriesPerPage = 10;

    useEffect(() => {
        fetchHelpdeskEntries();
    }, []);

    const fetchHelpdeskEntries = async () => {
        try {
            const response = await axios.get('https://taaiappapi.emedha.in/pages/api/api/helpdesk');
            setHelpdeskEntries(response.data);
        } catch (error) {
            console.error('Error fetching help desk entries:', error);
        }
    };

    const handleClose = () => {
        setShow(false);
        setIsEditing(false);
        setFormData({ description: '', call: '', whatsapp: '' });
    };

    const handleShow = () => setShow(true);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            if (isEditing) {
                await axios.put(`https://taaiappapi.emedha.in/pages/api/api/helpdesk/${editId}`, formData);
            } else {
                await axios.post('https://taaiappapi.emedha.in/pages/api/api/helpdesk', formData);
            }
            fetchHelpdeskEntries(); // Refresh the list
            handleClose();
        } catch (error) {
            console.error('Error saving help desk entry:', error);
        }
    };

    const handleEdit = (entry) => {
        setFormData(entry);
        setEditId(entry.id);
        setIsEditing(true);
        setShow(true);
    };

    const handleDelete = async (id) => {
        try {
            await axios.delete(`https://taaiappapi.emedha.in/pages/api/api/helpdesk/${id}`);
            fetchHelpdeskEntries(); // Refresh the list
        } catch (error) {
            console.error('Error deleting help desk entry:', error);
        }
    };

    // Pagination logic
    const indexOfLastEntry = currentPage * entriesPerPage;
    const indexOfFirstEntry = indexOfLastEntry - entriesPerPage;
    const currentEntries = helpdeskEntries.slice(indexOfFirstEntry, indexOfLastEntry);

    const totalPages = Math.ceil(helpdeskEntries.length / entriesPerPage);

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    return (
        <>
            <div className="container mt-5" style={{ fontSize: '14px' }}>
                <h4 style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', border: "1px solid grey", padding: '5px' }}>
                    <IoArrowBackCircle onClick={onBack} style={{ cursor: 'pointer' }} size={28} />
                    HELP DESK
                    <button style={{ backgroundColor: '#00a2ffff', color: 'white', border: 'none', padding: '4px 16px', fontSize: '14px', cursor: 'pointer', marginBottom: '10px', }} onClick={handleShow}>+ Add</button>
                </h4>

                <div className={`modal fade ${show ? 'show d-block' : ''}`} tabIndex="-1" role="dialog" style={{ backgroundColor: show ? 'rgba(0,0,0,0.5)' : 'transparent' }}>
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">{isEditing ? 'Edit Help Desk Entry' : 'Add Help Desk Entry'}</h5>
                                <button type="button" className="btn-close" onClick={handleClose}></button>
                            </div>
                            <div className="modal-body">
                                <form onSubmit={handleSubmit}>
                                    <div className="mb-3">
                                        <label htmlFor="formDescription" className="form-label">Description</label>
                                        <input type="text" className="form-control" id="formDescription" name="description" value={formData.description} onChange={handleChange} required style={{ borderRadius: '0px' }} />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="formCall" className="form-label">Call</label>
                                        <input type="text" className="form-control" id="formCall" name="call" value={formData.call} onChange={handleChange} required style={{ borderRadius: '0px' }} />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="formWhatsapp" className="form-label">WhatsApp</label>
                                        <input type="text" className="form-control" id="formWhatsapp" name="whatsapp" value={formData.whatsapp} onChange={handleChange} required style={{ borderRadius: '0px' }} />
                                    </div>

                                    <button type="submit" className="btn btn-primary btn-sm mt-2">{isEditing ? 'Update' : 'Submit'}</button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Table to display help desk entries */}
                <div className="table-responsive">
                    <Table striped bordered hover responsive>
                        <thead>
                            <tr>
                                <th>Description</th>
                                <th>Call</th>
                                <th>WhatsApp</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentEntries.map((entry) => (
                                <tr key={entry.id}>
                                    <td>{entry.description}</td>
                                    <td>{entry.call}</td>
                                    <td>{entry.whatsapp}</td>
                                    <td>
                                        <button variant="btn btn-warning btn-sm me-2" onClick={() => handleEdit(entry)}>Edit</button>
                                        <button variant="btn btn-danger btn-sm" onClick={() => handleDelete(entry.id)}>Delete</button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </div>
                <div className="d-flex justify-content-between mt-3">
                    <button disabled={currentPage === 1} onClick={() => handlePageChange(currentPage - 1)}>Previous</button>
                    <div>Page {currentPage} of {totalPages}</div>
                    <button disabled={currentPage === totalPages} onClick={() => handlePageChange(currentPage + 1)}>Next</button>
                </div>
            </div>
        </>
    );
};

const OnlineQuiz = ({ onBack }) => {
    const [show, setShow] = useState(false);
    const [pollEntries, setPollEntries] = useState([]);
    const [formData, setFormData] = useState({ topic: '', question: '' });
    const [options, setOptions] = useState(['', '', '', '']);
    const [correctAnswer, setCorrectAnswer] = useState('');
    const [isEditing, setIsEditing] = useState(false);
    const [editId, setEditId] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;

    useEffect(() => {
        fetchPollEntries();
    }, []);

    const fetchPollEntries = async () => {
        try {
            const response = await axios.get('https://taaiappapi.emedha.in/pages/api/api/quiz');
            console.log('Fetched Poll Entries:', response.data);
            setPollEntries(response.data);
        } catch (error) {
            console.error('Error fetching poll entries:', error);
        }
    };

    const handleClose = () => {
        setShow(false);
        setIsEditing(false);
        setFormData({ topic: '', question: '' });
        setOptions(['', '', '', '']);
        setCorrectAnswer('');
    };

    const handleShow = () => {
        setShow(true);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleOptionChange = (index, value) => {
        const newOptions = [...options];
        newOptions[index] = value;
        setOptions(newOptions);
    };

    const handleCorrectAnswerChange = (e) => {
        setCorrectAnswer(e.target.value);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const dataToSubmit = {
            ...formData,
            options: JSON.stringify(options),
            correctAnswer
        };

        try {
            if (isEditing) {
                await axios.put(`https://taaiappapi.emedha.in/pages/api/api/quiz/${editId}`, dataToSubmit);
            } else {
                await axios.post('https://taaiappapi.emedha.in/pages/api/api/quiz', dataToSubmit);
            }
            fetchPollEntries();
            handleClose();
        } catch (error) {
            console.error('Error saving poll entry:', error);
        }
    };

    const handleEdit = (entry) => {
        setFormData({ topic: entry.topic, question: entry.question });

        try {
            const parsedOptions = JSON.parse(entry.options);
            setOptions(parsedOptions);
        } catch (error) {
            console.error('Error parsing options:', error, 'Options:', entry.options);
            setOptions(['', '', '', '']);
        }

        setCorrectAnswer(entry.correctAnswer);
        setEditId(entry.id);
        setIsEditing(true);
        setShow(true);
    };

    const handleDelete = async (id) => {
        try {
            await axios.delete(`https://taaiappapi.emedha.in/pages/api/api/quiz/${id}`);
            fetchPollEntries();
        } catch (error) {
            console.error('Error deleting poll entry:', error);
        }
    };

    // Calculate current entries for pagination
    const indexOfLastEntry = currentPage * itemsPerPage;
    const indexOfFirstEntry = indexOfLastEntry - itemsPerPage;
    const currentEntries = pollEntries.slice(indexOfFirstEntry, indexOfLastEntry);

    // Calculate total pages
    const totalPages = Math.ceil(pollEntries.length / itemsPerPage);

    return (
        <>
            <div className="container mt-5" style={{ fontSize: '14px' }}>
                <h4 style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', border: "1px solid grey", padding: '5px' }}>
                    <IoArrowBackCircle onClick={onBack} style={{ cursor: 'pointer' }} size={28} />
                    ONLINE QUIZ
                    <button style={{ backgroundColor: '#00a2ffff', color: 'white', border: 'none', padding: '4px 16px', fontSize: '14px', cursor: 'pointer', marginBottom: '10px', }} onClick={handleShow}>+ Add</button>
                </h4>

                <Modal show={show} onHide={handleClose}>
                    <Modal.Header closeButton>
                        <Modal.Title>{isEditing ? 'Edit Poll Entry' : 'Add Poll Entry'}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <form onSubmit={handleSubmit}>
                            <div className="mb-3">
                                <label htmlFor="formTopic" className="form-label">Topic</label>
                                <input type="text" className="form-control" id="formTopic" name="topic" value={formData.topic} onChange={handleChange} required style={{ borderRadius: '0px' }} />
                            </div>
                            <div className="mb-3">
                                <label htmlFor="formQuestion" className="form-label">Poll Question</label>
                                <input type="text" className="form-control" id="formQuestion" name="question" value={formData.question} onChange={handleChange} required style={{ borderRadius: '0px' }} />
                            </div>
                            {options.map((option, index) => (
                                <div className="mb-3" key={index}>
                                    <label htmlFor={`formOption${index}`} className="form-label">Option {index + 1}</label>
                                    <input type="text" className="form-control" id={`formOption${index}`} value={option} onChange={(e) => handleOptionChange(index, e.target.value)} required style={{ borderRadius: '0px' }} />
                                </div>
                            ))}
                            <div className="mb-3">
                                <label htmlFor="formCorrectAnswer" className="form-label">Correct Answer</label>
                                <input type="text" className="form-control" id="formCorrectAnswer" value={correctAnswer} onChange={handleCorrectAnswerChange} required style={{ borderRadius: '0px' }} />
                            </div>
                            <button type="submit" className="btn btn-primary btn-sm mt-3">{isEditing ? 'Update' : 'Submit'}</button>
                        </form>
                    </Modal.Body>
                </Modal>

                <div className="table-responsive">
                    <Table striped bordered hover responsive>
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Topic</th>
                                <th>Poll Question</th>
                                <th>Options</th>
                                <th>Answer</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentEntries.map((entry, index) => (
                                <tr key={entry.id}>
                                    <td>{index + 1 + (currentPage - 1) * itemsPerPage}</td>
                                    <td>{entry.topic}</td>
                                    <td>{entry.question}</td>
                                    <td>
                                        {(() => {
                                            try {
                                                const parsedOptions = JSON.parse(entry.options);
                                                if (Array.isArray(parsedOptions)) {
                                                    return parsedOptions.join(', ');
                                                }
                                            } catch (error) {
                                                console.error('Error parsing options:', error);
                                            }
                                            return entry.options || 'No options available';
                                        })()}
                                    </td>
                                    <td>{entry.correctAnswer}</td>
                                    <td>
                                        <button variant="btn btn-warning btn-sm me-2" onClick={() => handleEdit(entry)}>Edit</button>
                                        <button variant="btn btn-danger btn-sm" onClick={() => handleDelete(entry.id)}>Delete</button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </div>

                {/* Pagination Controls */}
                <Pagination className="justify-content-center mt-4">
                    <Pagination.Prev onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))} disabled={currentPage === 1} />
                    {[...Array(totalPages).keys()].map(page => (
                        <Pagination.Item key={page + 1} active={page + 1 === currentPage} onClick={() => setCurrentPage(page + 1)}>{page + 1}</Pagination.Item>
                    ))}
                    <Pagination.Next onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))} disabled={currentPage === totalPages} />
                </Pagination>
            </div>
        </>
    );
};

// const Notifications = ({ onBack }) => {
//     const [show, setShow] = useState(false);
//     const [notifications, setNotifications] = useState([]);
//     const [formData, setFormData] = useState({ title: '', description: '' });
//     const [isEditing, setIsEditing] = useState(false);
//     const [editId, setEditId] = useState(null);

//     // Pagination state
//     const [currentPage, setCurrentPage] = useState(1);
//     const entriesPerPage = 10;

//     useEffect(() => {
//         fetchNotifications();
//     }, []);

//     const fetchNotifications = async () => {
//         try {
//             const response = await axios.get('https://taaiappapi.emedha.in/pages/api/api/notifications');
//             setNotifications(response.data);
//         } catch (error) {
//             console.error('Error fetching notifications:', error);
//         }
//     };

//     const handleClose = () => {
//         setShow(false);
//         setIsEditing(false);
//         setFormData({ title: '', description: '' });
//     };

//     const handleShow = () => {
//         setShow(true);
//     };

//     const handleChange = (e) => {
//         const { name, value } = e.target;
//         setFormData({ ...formData, [name]: value });
//     };

//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         try {
//             if (isEditing) {
//                 await axios.put(`https://taaiappapi.emedha.in/pages/api/api/notifications/${editId}`, formData);
//             } else {
//                 await axios.post('https://taaiappapi.emedha.in/pages/api/api/notifications', formData);
//             }
//             fetchNotifications(); // Refresh the notifications list
//             handleClose();
//         } catch (error) {
//             console.error('Error saving notification:', error);
//         }
//     };

//     const handleEdit = (notification) => {
//         setFormData(notification);
//         setEditId(notification.id);
//         setIsEditing(true);
//         setShow(true);
//     };

//     const handleDelete = async (id) => {
//         try {
//             await axios.delete(`https://taaiappapi.emedha.in/pages/api/api/notifications/${id}`);
//             fetchNotifications(); // Refresh the notifications list
//         } catch (error) {
//             console.error('Error deleting notification:', error);
//         }
//     };

//     // Pagination logic
//     const indexOfLastEntry = currentPage * entriesPerPage;
//     const indexOfFirstEntry = indexOfLastEntry - entriesPerPage;
//     const currentEntries = notifications.slice(indexOfFirstEntry, indexOfLastEntry);

//     const totalPages = Math.ceil(notifications.length / entriesPerPage);

//     const handlePageChange = (pageNumber) => {
//         setCurrentPage(pageNumber);
//     };

//     return (
//         <>
//             <div className="container mt-5" style={{ fontSize: '14px' }}>
//                 <h4 style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', border: "1px solid grey", padding: '5px' }}>
//                     <IoArrowBackCircle onClick={onBack} style={{ cursor: 'pointer' }} size={28} />
//                     NOTIFICATION
//                     <button style={{ backgroundColor: '#00a2ffff', color: 'white', border: 'none', padding: '4px 16px', fontSize: '14px', cursor: 'pointer', marginBottom: '10px', }} onClick={handleShow}>+ Add</button>
//                 </h4>

//                 <Modal show={show} onHide={handleClose}>
//                     <Modal.Header closeButton>
//                         <Modal.Title>{isEditing ? 'Edit Notification' : 'Add Notification'}</Modal.Title>
//                     </Modal.Header>
//                     <Modal.Body>
//                         <form onSubmit={handleSubmit}>
//                             <div className="mb-3">
//                                 <label htmlFor="formTitle" className="form-label">Title</label>
//                                 <input type="text" className="form-control" id="formTitle" name="title" value={formData.title} onChange={handleChange} required style={{ borderRadius: '0px' }} />
//                             </div>
//                             <div className="mb-3">
//                                 <label htmlFor="formDescription" className="form-label">Description</label>
//                                 <textarea className="form-control" id="formDescription" name="description" rows="3" value={formData.description} onChange={handleChange} required style={{ borderRadius: '0px' }}></textarea>
//                             </div>
//                             <button type="submit" className="btn btn-primary btn-sm mt-3">{isEditing ? 'Update' : 'Submit'}</button>
//                         </form>
//                     </Modal.Body>
//                 </Modal>

//                 <Table striped bordered hover responsive>
//                     <thead>
//                         <tr>
//                             <th>Title</th>
//                             <th>Description</th>
//                             <th>Actions</th>
//                         </tr>
//                     </thead>
//                     <tbody>
//                         {currentEntries.map((notification) => (
//                             <tr key={notification.id}>
//                                 <td>{notification.title}</td>
//                                 <td>{notification.description}</td>
//                                 <td>
//                                     <button variant="btn btn-warning btn-sm me-2" onClick={() => handleEdit(notification)}>Edit</button>
//                                     <button variant="btn btn-danger btn-sm" onClick={() => handleDelete(notification.id)}>Delete</button>
//                                 </td>
//                             </tr>
//                         ))}
//                     </tbody>
//                 </Table>

//                 {/* Pagination Controls */}
//                 <div className="d-flex justify-content-between mt-3">
//                     <button disabled={currentPage === 1} onClick={() => handlePageChange(currentPage - 1)}>Previous</button>
//                     <div>Page {currentPage} of {totalPages}</div>
//                     <button disabled={currentPage === totalPages} onClick={() => handlePageChange(currentPage + 1)}>Next</button>
//                 </div>
//             </div>
//         </>
//     );
// };

const Notifications = ({ onBack }) => {
    const [show, setShow] = useState(false);
    const [notifications, setNotifications] = useState([]);
    const [formData, setFormData] = useState({ title: '', description: '' });
    const [bannerImage, setBannerImage] = useState(null); // Added state for optional image
    const [isEditing, setIsEditing] = useState(false);
    const [editId, setEditId] = useState(null);

    // Pagination state
    const [currentPage, setCurrentPage] = useState(1);
    const entriesPerPage = 10;

    useEffect(() => {
        fetchNotifications();
    }, []);

    const fetchNotifications = async () => {
        try {
            const response = await axios.get('https://taaiappapi.emedha.in/pages/api/api/notifications');
            setNotifications(response.data);
        } catch (error) {
            console.error('Error fetching notifications:', error);
        }
    };

    const handleClose = () => {
        setShow(false);
        setIsEditing(false);
        setFormData({ title: '', description: '' });
        setBannerImage(null);
    };

    const handleShow = () => {
        setShow(true);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    // Handle File Input Change
    const handleFileChange = (e) => {
        setBannerImage(e.target.files[0]);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const data = new FormData();
            data.append('title', formData.title);
            data.append('description', formData.description);
            if (bannerImage) {
                data.append('banner_image', bannerImage);
            }

            const config = {
                headers: { 'Content-Type': 'multipart/form-data' }
            };

            if (isEditing) {
                await axios.put(`https://taaiappapi.emedha.in/pages/api/api/notifications/${editId}`, data, config);
            } else {
                await axios.post('https://taaiappapi.emedha.in/pages/api/api/notifications', data, config);
            }
            fetchNotifications(); // Refresh the list
            handleClose();
        } catch (error) {
            console.error('Error saving notification:', error);
        }
    };

    const handleEdit = (notification) => {
        setFormData({ title: notification.title, description: notification.description });
        setEditId(notification.id);
        setIsEditing(true);
        setShow(true);
    };

    const handleDelete = async (id) => {
        try {
            await axios.delete(`https://taaiappapi.emedha.in/pages/api/api/notifications/${id}`);
            fetchNotifications();
        } catch (error) {
            console.error('Error deleting notification:', error);
        }
    };

    // Pagination logic
    const indexOfLastEntry = currentPage * entriesPerPage;
    const indexOfFirstEntry = indexOfLastEntry - entriesPerPage;
    const currentEntries = notifications.slice(indexOfFirstEntry, indexOfLastEntry);
    const totalPages = Math.ceil(notifications.length / entriesPerPage);

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    return (
        <>
            <div className="container mt-5" style={{ fontSize: '14px' }}>
                <h4 style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', border: "1px solid grey", padding: '5px' }}>
                    <IoArrowBackCircle onClick={onBack} style={{ cursor: 'pointer' }} size={28} />
                    NOTIFICATION
                    <button style={{ backgroundColor: '#00a2ffff', color: 'white', border: 'none', padding: '4px 16px', fontSize: '14px', cursor: 'pointer', marginBottom: '10px' }} onClick={handleShow}>+ Add</button>
                </h4>

                <Modal show={show} onHide={handleClose}>
                    <Modal.Header closeButton>
                        <Modal.Title>{isEditing ? 'Edit Notification' : 'Add Notification'}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <form onSubmit={handleSubmit}>
                            <div className="mb-3">
                                <label htmlFor="formTitle" className="form-label">Title</label>
                                <input type="text" className="form-control" id="formTitle" name="title" value={formData.title} onChange={handleChange} required style={{ borderRadius: '0px' }} />
                            </div>
                            <div className="mb-3">
                                <label htmlFor="formDescription" className="form-label">Description</label>
                                <textarea className="form-control" id="formDescription" name="description" rows="3" value={formData.description} onChange={handleChange} required style={{ borderRadius: '0px' }}></textarea>
                            </div>
                            {/* Optional Banner Image Input */}
                            <div className="mb-3">
                                <label htmlFor="formBannerImage" className="form-label">Banner Image (Optional)</label>
                                <input type="file" className="form-control" id="formBannerImage" accept="image/*" onChange={handleFileChange} style={{ borderRadius: '0px' }} />
                            </div>
                            <button type="submit" className="btn btn-primary btn-sm mt-3">{isEditing ? 'Update' : 'Submit'}</button>
                        </form>
                    </Modal.Body>
                </Modal>

                <Table striped bordered hover responsive>
                    <thead>
                        <tr>
                            <th>Banner</th>
                            <th>Title</th>
                            <th>Description</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {currentEntries.map((notification) => (
                            <tr key={notification.id}>
                                <td>
                                    {notification.banner_image ? (
                                        <img src={notification.banner_image} alt="banner" style={{ width: '50px', height: '50px', objectFit: 'cover' }} />
                                    ) : (
                                        'No Image'
                                    )}
                                </td>
                                <td>{notification.title}</td>
                                <td>{notification.description}</td>
                                <td>
                                    <button className="btn btn-warning btn-sm me-2" onClick={() => handleEdit(notification)}>Edit</button>
                                    <button className="btn btn-danger btn-sm" onClick={() => handleDelete(notification.id)}>Delete</button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>

                {/* Pagination Controls */}
                <div className="d-flex justify-content-between mt-3">
                    <button disabled={currentPage === 1} onClick={() => handlePageChange(currentPage - 1)}>Previous</button>
                    <div>Page {currentPage} of {totalPages}</div>
                    <button disabled={currentPage === totalPages} onClick={() => handlePageChange(currentPage + 1)}>Next</button>
                </div>
            </div>
        </>
    );
};





const EventCalendar = ({ onBack }) => {
    const [showModal, setShowModal] = useState(false);
    const [formData, setFormData] = useState({ name: '', description: '', venue: '', schedule: '', date: '' });
    const [events, setEvents] = useState([]);
    const [editingId, setEditingId] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;

    useEffect(() => {
        fetchEvents();
    }, []);

    const fetchEvents = async () => {
        try {
            const response = await fetch('https://taaiappapi.emedha.in/pages/api/api/events');
            const data = await response.json();

            console.log(data)
            if (Array.isArray(data)) {
                const groupedEvents = data.reduce((acc, event) => {
                    const eventDate = new Date(event.date).toLocaleDateString();
                    if (!acc[eventDate]) acc[eventDate] = [];
                    acc[eventDate].push(event);
                    return acc;
                }, {});

                const sortedDates = Object.keys(groupedEvents).sort((a, b) => new Date(a) - new Date(b));

                const sortedEvents = {};
                sortedDates.forEach(date => {
                    sortedEvents[date] = groupedEvents[date];
                });

                setEvents(sortedEvents);

            } else {
                console.error('Expected an array but received:', data);
                setEvents({});
            }
        } catch (error) {
            console.error('Error fetching events:', error);
            setEvents({});
        }
    };

    const handleShow = (event = null) => {
        if (event) {
            setFormData({
                name: event.name,
                description: event.description,
                venue: event.venue,
                schedule: event.schedule,
                date: event.date,
            });
            setEditingId(event.id);
        } else {
            setFormData({ name: '', venue: '', schedule: '', date: '' });
            setEditingId(null);
        }
        setShowModal(true);
    };


    const handleClose = () => setShowModal(false);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };


    const handleSubmit = async (e) => {
        e.preventDefault();

        const method = editingId ? 'PUT' : 'POST';
        const url = editingId
            ? `https://taaiappapi.emedha.in/pages/api/api/events/${editingId}`
            : 'https://taaiappapi.emedha.in/pages/api/api/events';

        const eventData = {};
        if (formData.name) eventData.name = formData.name;
        if (formData.description) eventData.description = formData.description;
        if (formData.venue) eventData.venue = formData.venue;
        if (formData.schedule) eventData.schedule = formData.schedule;
        if (formData.date) eventData.date = formData.date;

        try {
            const response = await fetch(url, {
                method,
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(eventData),
            });

            if (response.ok) {
                fetchEvents();
                handleClose();
            } else {
                console.error('Error submitting event:', response.statusText);
            }
        } catch (error) {
            console.error('Error submitting event:', error);
        }
    };


    const handleDelete = async (eventId) => {
        if (window.confirm('Are you sure you want to delete this event?')) {
            const response = await fetch(`https://taaiappapi.emedha.in/pages/api/api/events/${eventId}`, {
                method: 'DELETE',
            });
            if (response.ok) {
                fetchEvents(); // Refresh events list
            } else {
                console.error('Error deleting event:', response.statusText);
            }
        }
    };


    // Pagination logic for dates (not events directly)
    const totalPages = Math.ceil(Object.keys(events).length / itemsPerPage);
    const currentDates = Object.keys(events).slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

    return (
        <>
            <>
                <div className="container mt-5" style={{ fontSize: '14px' }}>
                    <h4 style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', border: "1px solid grey", padding: '5px' }}>
                        <IoArrowBackCircle onClick={onBack} style={{ cursor: 'pointer' }} size={28} />
                        EVENT CALENDER
                        <button style={{ backgroundColor: '#00a2ffff', color: 'white', border: 'none', padding: '4px 16px', fontSize: '14px', cursor: 'pointer', marginBottom: '10px', }} onClick={handleShow}>+ Add</button>
                    </h4>

                    <Table striped bordered hover responsive="sm">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Schedule</th>
                                <th>Particulars</th>
                                <th>Dress Code</th>
                                <th>Venue / Remarks </th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentDates.map((date, index) => (
                                <React.Fragment key={date}>
                                    <tr>
                                        <td colSpan="7" style={{ textAlign: 'center', fontWeight: 'bold' }}>
                                            {new Date(date).toLocaleDateString('en-US', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}
                                        </td>
                                    </tr>
                                    {Array.isArray(events[date]) && events[date].map((event, eventIndex) => (
                                        <tr key={event.id}>
                                            <td>{(currentPage - 1) * itemsPerPage + index + eventIndex + 1}</td>
                                            <td>{event.schedule}</td>
                                            <td>{event.name}</td>
                                            <td>{event.description || ''}</td>
                                            <td>{event.venue || ''}</td>
                                            <td>
                                                <FaEdit className='me-3' style={{ cursor: 'pointer' }} onClick={() => handleShow(event)} />
                                                <MdDelete style={{ cursor: 'pointer' }} onClick={() => handleDelete(event.id)} />
                                            </td>
                                        </tr>
                                    ))}
                                </React.Fragment>
                            ))}
                        </tbody>
                    </Table>

                    {/* Modal for Adding/Editing Events */}
                    <Modal show={showModal} onHide={handleClose} size="lg">
                        <Modal.Header closeButton>
                            <Modal.Title>{editingId ? 'Edit Event' : 'Add Event'}</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <form onSubmit={handleSubmit}>
                                <div className="mb-3">
                                    <label htmlFor="schedule" className="form-label">Schedule Time</label>
                                    <input type="text" className="form-control" id="schedule" name="schedule" value={formData.schedule} onChange={handleInputChange} style={{ borderRadius: "0px" }} />
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="name" className="form-label">Particulars</label>
                                    <textarea type="text" className="form-control" id="name" name="name" value={formData.name} onChange={handleInputChange} style={{ borderRadius: "0px" }} />
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="description" className="form-label">Dress Code</label>
                                    <input type="text" className="form-control" id="description" name="description" value={formData.description} onChange={handleInputChange} style={{ borderRadius: "0px" }} />
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="venue" className="form-label">Venue / Remarks</label>
                                    <textarea type="text" className="form-control" id="venue" name="venue" value={formData.venue} onChange={handleInputChange} style={{ borderRadius: "0px" }} />
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="date" className="form-label">Date</label>
                                    <input type="date" className="form-control" id="date" name="date" value={formData.date} onChange={handleInputChange} min={new Date().toISOString().split("T")[0]} style={{ borderRadius: "0px" }} />
                                </div>
                                <button className="btn btn-primary btn-sm" type="submit">Submit</button>
                            </form>
                        </Modal.Body>
                    </Modal>

                    {/* Pagination Controls */}
                    <Pagination className="justify-content-center mt-4">
                        <Pagination.Prev onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))} disabled={currentPage === 1} />
                        {[...Array(totalPages).keys()].map(page => (
                            <Pagination.Item key={page + 1} active={page + 1 === currentPage} onClick={() => setCurrentPage(page + 1)}>
                                {page + 1}
                            </Pagination.Item>
                        ))}
                        <Pagination.Next onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))} disabled={currentPage === totalPages} />
                    </Pagination>
                </div>
            </>
        </>
    );
};

const Speakers = ({ onBack }) => {
    const [showModal, setShowModal] = useState(false);
    const [formData, setFormData] = useState({ name: '', title: '', image: null });
    const [speakers, setSpeakers] = useState([]);
    const [editIndex, setEditIndex] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;

    useEffect(() => {
        const fetchSpeakers = async () => {
            try {
                const response = await axios.get('https://taaiappapi.emedha.in/pages/api/api/speakers');
                setSpeakers(response.data);
            } catch (error) {
                console.error('Error fetching speakers:', error);
            }
        };
        fetchSpeakers();
    }, []);

    const handleShow = (index = null) => {
        if (index !== null && speakers[index]) {
            setFormData({
                name: speakers[index].name,
                title: speakers[index].title,
                image: null,
            });
            setEditIndex(index);
        } else {
            setFormData({ name: '', title: '', image: null });
            setEditIndex(null);
        }
        setShowModal(true);
    };

    const handleClose = () => setShowModal(false);

    const handleInputChange = (e) => {
        const { name, value, files } = e.target;
        if (name === 'image') {
            setFormData({ ...formData, image: files[0] });
        } else {
            setFormData({ ...formData, [name]: value });
        }
    };


    const handleSubmit = async (e) => {
        e.preventDefault();
        console.log("Submitting form...");
        const { name, title, image } = formData;
        const formDataToSend = new FormData();
        formDataToSend.append('name', name);
        formDataToSend.append('title', title);
        if (image) {
            formDataToSend.append('image', image);
        }
        try {
            if (editIndex !== null && speakers[editIndex]) {
                await axios.put(`https://taaiappapi.emedha.in/pages/api/api/speakers/${speakers[editIndex].id}`, formDataToSend);
            } else {
                const response = await axios.post('https://taaiappapi.emedha.in/pages/api/api/speakers', formDataToSend);
                setSpeakers([...speakers, response.data]);
            }
            setFormData({ name: '', title: '', image: '' });
            handleClose();
        } catch (error) {
            console.error('Error saving speaker:', error);
        }
    };

    const handleDelete = async (index) => {
        const speakerToDelete = speakers[index];
        if (window.confirm(`Are you sure you want to delete ${speakerToDelete.name}?`)) {
            try {
                await axios.delete(`https://taaiappapi.emedha.in/pages/api/api/speakers/${speakerToDelete.id}`);
                const newSpeakers = speakers.filter((_, i) => i !== index);
                setSpeakers(newSpeakers);
            } catch (error) {
                console.error('Error deleting speaker:', error);
            }
        }
    };
    // Pagination Logic
    const totalPages = Math.ceil(speakers.length / itemsPerPage);
    const currentSpeakers = speakers.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

    return (
        <>
            <div className="container mt-5">
                <h4 style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', border: "1px solid grey", padding: '5px' }}>
                    <IoArrowBackCircle onClick={onBack} style={{ cursor: 'pointer' }} size={28} />
                    SPEAKERS & SESSIONS
                    <button style={{ backgroundColor: '#00a2ffff', color: 'white', border: 'none', padding: '4px 16px', fontSize: '14px', cursor: 'pointer', marginBottom: '10px', }} onClick={handleShow}>+ Add</button>
                </h4>
                <div className="table-responsive">
                    <table className="table table-bordered table-striped">
                        <thead className="table-primary">
                            <tr>
                                <th>#</th>
                                <th>Name Of The Speaker</th>
                                <th>Title</th>
                                <th>Image</th>
                                {/* <th>QR Code</th> */}
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentSpeakers.map((speaker, index) => {
                                const titleParts = speaker.title.split('\r\n');
                                const eventDateString = titleParts.find(part => /\d{1,2}-\d{1,2}-\d{4}/.test(part));
                                const speakerData = { name: speaker.name, title: speaker.title, imageUrl: speaker.imageUrl, eventDate: eventDateString, };
                                return (
                                    <tr key={speaker.id}>
                                        <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                                        <td>{speaker.name}</td>
                                        <td>{speaker.title}</td>
                                        <td><img src={speaker.imageUrl} alt={speaker.name} style={{ width: '100px' }} /></td>
                                        {/* <td><QRCodeCanvas value={JSON.stringify(speakerData)} size={128} /></td> */}
                                        <td>
                                            <FaEdit className='me-3' style={{ cursor: 'pointer' }} onClick={() => handleShow((currentPage - 1) * itemsPerPage + index)} />
                                            <MdDelete style={{ cursor: 'pointer' }} onClick={() => handleDelete((currentPage - 1) * itemsPerPage + index)} />
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>

                <Modal show={showModal} onHide={handleClose} size="lg">
                    <Modal.Header closeButton><Modal.Title>{editIndex !== null ? 'EDIT SPEAKER' : 'ADD SPEAKER'}</Modal.Title></Modal.Header>
                    <Modal.Body>
                        <form onSubmit={handleSubmit}>
                            <div className="mb-3">
                                <label htmlFor="name" className="form-label">Name Of The Speaker</label>
                                <input type="text" className="form-control" id="name" name="name" value={formData.name} onChange={handleInputChange} style={{ borderRadius: "0px" }} />
                            </div>
                            <div className="mb-3">
                                <label htmlFor="title" className="form-label">Title</label>
                                <textarea className="form-control" id="title" name="title" value={formData.title} onChange={handleInputChange} style={{ borderRadius: "0px" }} />
                            </div>
                            <div className="mb-3">
                                <label htmlFor="image" className="form-label">Upload Image</label>
                                <input type="file" className="form-control" id="image" name="image" accept="image/*" onChange={handleInputChange} style={{ borderRadius: "0px" }} />
                            </div>
                            <button className="btn btn-primary btn-sm" type="submit">Submit</button>
                        </form>
                    </Modal.Body>
                </Modal>

                <Pagination className="justify-content-center mt-4">
                    <Pagination.Prev onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))} disabled={currentPage === 1} />
                    {[...Array(totalPages).keys()].map(page => (
                        <Pagination.Item key={page + 1} active={page + 1 === currentPage} onClick={() => setCurrentPage(page + 1)}>
                            {page + 1}
                        </Pagination.Item>
                    ))}
                    <Pagination.Next onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))} disabled={currentPage === totalPages} />
                </Pagination>
            </div>
        </>
    );
};

const Dashboard = () => {
    const [activeSection, setActiveSection] = useState(null);
    const [dropdownVisible, setDropdownVisible] = useState(false);
    const navigate = useNavigate();
    const handleLogout = () => {
        localStorage.removeItem('userData');
        sessionStorage.removeItem('userType');
        navigate('/');
        console.log('Logging out...');
        setDropdownVisible(false);
    };
    const toggleDropdown = () => {
        setDropdownVisible(!dropdownVisible);
    };
    return (
        <div style={{ fontFamily: 'Arial, sans-serif', textAlign: 'center', }}>

            <div style={{ backgroundColor: '#ece8e8ff', display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '10px 30px', }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', maxWidth: '1200px', margin: '0 auto' }}>
                    <img src={logo} alt="Logo" style={{ width: '200px', height: '60px', borderRadius: "20px" }} />
                    <h1 style={{ flexGrow: 1, textAlign: 'center', color: '#2c318d', fontSize: '28px', fontWeight: 'bold', }}>ADMIN DASHBOARD</h1>
                    <>
                        <FaUserCircle style={{ fontSize: '32px', color: 'black', cursor: 'pointer', }} onClick={toggleDropdown} />
                        {dropdownVisible && (
                            <div style={{ position: 'absolute', right: '30px', top: '70px', backgroundColor: '#fff', zIndex: 1000, boxShadow: '0 4px 12px rgba(0,0,0,0.15)', minWidth: '160px', animation: 'fadeIn 0.3s ease-in-out' }}>
                                <div style={{ padding: '10px', display: 'flex', flexDirection: 'column', }}>
                                    <button onClick={handleLogout} style={{ backgroundColor: '#e53935', color: '#fff', border: 'none', padding: '10px', fontSize: '14px', cursor: 'pointer', transition: 'background 0.3s ease', display: 'flex', alignItems: 'center', gap: '8px' }} onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#c62828'} onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#e53935'}><FaSignOutAlt />Logout</button>
                                </div>
                            </div>
                        )}
                    </>
                </div>
            </div>

            <hr></hr>

            {!activeSection && (
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: '20px', padding: '40px', maxWidth: '1000px', margin: 'auto', }}>
                    {sections.map((section, index) => (
                        <button key={index} style={{ backgroundColor: '#8d2c2cff', color: 'white', border: 'none', padding: '10px', fontSize: '14px', cursor: 'pointer', transition: 'background-color 0.3s ease', }} onMouseOver={e => (e.target.style.backgroundColor = '#1e2465')} onMouseOut={e => (e.target.style.backgroundColor = '#2c318d')} onClick={() => setActiveSection(section)}>
                            {section}
                        </button>
                    ))}
                </div>
            )}

            {activeSection === "Menu Items" && <MenuItems onBack={() => setActiveSection(null)} />}
            {activeSection === "Stalls" && <Stalls onBack={() => setActiveSection(null)} />}
            {activeSection === "Help Desk" && <Helpdesk onBack={() => setActiveSection(null)} />}
            {activeSection === "Online Quiz" && <OnlineQuiz onBack={() => setActiveSection(null)} />}
            {activeSection === "Notifications" && <Notifications onBack={() => setActiveSection(null)} />}
            {activeSection === "Event Calendar" && <EventCalendar onBack={() => setActiveSection(null)} />}
            {activeSection === "Speakers & Sessions" && <Speakers onBack={() => setActiveSection(null)} />}
            {activeSection === "Download" && <Download onBack={() => setActiveSection(null)} />}
            {activeSection === 'Register' && <Register onBack={() => setActiveSection(null)} />}
            {activeSection === 'Taai Membership' && <TaaiMembership onBack={() => setActiveSection(null)} />}
            {activeSection === "Attendance" && <Attendance onBack={() => setActiveSection(null)} />}
            {activeSection === "Gallery" && <Gallery onBack={() => setActiveSection(null)} />}
            {activeSection === "Networking" && <Networking onBack={() => setActiveSection(null)} />}
            {activeSection === "StallScans" && <StallScans onBack={() => setActiveSection(null)} />}
            {activeSection === "BizSession" && <BizSession onBack={() => setActiveSection(null)} />}
            {activeSection === "Sliders" && <Sliders onBack={() => setActiveSection(null)} />}
            {activeSection && activeSection !== "Menu Items" && activeSection !== "Stalls" && activeSection !== "Help Desk" && activeSection !== "Online Quiz" &&
                activeSection !== "Notifications" && activeSection !== "Event Calendar" && activeSection !== "Speakers & Sessions" && activeSection !== "Download" && activeSection !== "Register" && activeSection !== "Taai Membership" && activeSection !== "Attendance" && activeSection !== "Gallery" && activeSection !== "Networking" && activeSection !== "StallScans" && activeSection !== "BizSession" && activeSection !== "Sliders" &&(
                    <div style={{ padding: '20px', marginTop: '20px', border: '1px solid #ccc', maxWidth: '1200px', margin: '20px auto', textAlign: 'left', backgroundColor: '#f9f9f9', }}>
                        <button style={{ backgroundColor: '#999', color: 'white', border: 'none', padding: '8px 16px', fontSize: '14px', cursor: 'pointer', marginBottom: '10px', }} onClick={() => setActiveSection(null)}>← Back</button>
                        <h2>{activeSection}</h2>
                        <p>{sectionData[activeSection] || "Content coming soon."}</p>
                    </div>
                )}
        </div>
    );
};



const Download = ({ onBack }) => {
    const [showModal, setShowModal] = useState(false);
    const [formData, setFormData] = useState({ title: '', file: null });
    const [uploads, setUploads] = useState([]);
    const [editIndex, setEditIndex] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;

    useEffect(() => {
        const fetchUploads = async () => {
            try {
                const response = await axios.get('https://taaiappapi.emedha.in/auth/api/get/doc');
                setUploads(response.data);
            } catch (error) {
                console.error('Error fetching uploads:', error);
            }
        };
        fetchUploads();
    }, []);

    const handleShow = () => {
        setFormData({ title: '', file: null });
        setEditIndex(null);
        setShowModal(true);
    };

    const handleClose = () => setShowModal(false);

    const handleInputChange = (e) => {
        const { name, value, files } = e.target;
        if (name === 'file') {
            setFormData({ ...formData, file: files[0] });
        } else {
            setFormData({ ...formData, [name]: value });
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const { title, file } = formData;
        const data = new FormData();
        data.append('title', title);
        if (file) data.append('file', file);

        try {
            const response = await axios.post('https://taaiappapi.emedha.in/auth/api/post/doc', data);
            setUploads([response.data, ...uploads]);
            setFormData({ title: '', file: null });
            handleClose();
        } catch (error) {
            console.error('Upload failed:', error);
        }
    };

    const handleDelete = async (index) => {
        const fileToDelete = uploads[index];
        if (window.confirm(`Delete file titled "${fileToDelete.title}"?`)) {
            try {
                await axios.delete(`https://taaiappapi.emedha.in/auth/api/delete/doc/${fileToDelete.id}`);
                const updated = uploads.filter((_, i) => i !== index);
                setUploads(updated);
            } catch (error) {
                console.error('Delete failed:', error);
            }
        }
    };

    const totalPages = Math.ceil(uploads.length / itemsPerPage);
    const currentUploads = uploads.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

    return (
        <div className="container mt-5">
            <h4 style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <IoArrowBackCircle onClick={onBack} style={{ cursor: 'pointer' }} size={28} />
                Upload Files
                <button className="btn btn-primary btn-sm" onClick={handleShow}>+ Add</button>
            </h4>

            <table className="table table-bordered mt-3">
                <thead className="table-primary">
                    <tr>
                        <th>#</th>
                        <th>Title</th>
                        <th>File</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {currentUploads.map((upload, index) => (
                        <tr key={upload.id}>
                            <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                            <td>{upload.title}</td>
                            <td>
                                <a href={upload.file_url} target="_blank" rel="noreferrer">Download</a>
                            </td>
                            <td>
                                <MdDelete style={{ cursor: 'pointer' }} onClick={() => handleDelete((currentPage - 1) * itemsPerPage + index)} />
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>

            <Pagination className="justify-content-center">
                <Pagination.Prev onClick={() => setCurrentPage(p => Math.max(p - 1, 1))} disabled={currentPage === 1} />
                {[...Array(totalPages).keys()].map(p => (
                    <Pagination.Item key={p + 1} active={currentPage === p + 1} onClick={() => setCurrentPage(p + 1)}>
                        {p + 1}
                    </Pagination.Item>
                ))}
                <Pagination.Next onClick={() => setCurrentPage(p => Math.min(p + 1, totalPages))} disabled={currentPage === totalPages} />
            </Pagination>

            <Modal show={showModal} onHide={handleClose} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>Add New File</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form onSubmit={handleSubmit}>
                        <div className="mb-3">
                            <label>Title</label>
                            <textarea className="form-control" name="title" value={formData.title} onChange={handleInputChange}></textarea>
                        </div>
                        <div className="mb-3">
                            <label>Upload File</label>
                            <input type="file" className="form-control" name="file" onChange={handleInputChange} />
                        </div>
                        <button className="btn btn-primary">Submit</button>
                    </form>
                </Modal.Body>
            </Modal>
        </div>
    );
};




const Register = ({ onBack }) => {
    const [showModal, setShowModal] = useState(false);
    const [formData, setFormData] = useState({ title: '', url: '' });
    const [records, setRecords] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;

    useEffect(() => {
        fetchRecords();
    }, []);

    const fetchRecords = async () => {
        try {
            const response = await axios.get('https://taaiappapi.emedha.in/auth/api/api/urls');
            setRecords(response.data);
        } catch (error) {
            console.error('Error fetching records:', error);
        }
    };

    const handleShow = () => {
        setFormData({ title: '', url: '' });
        setShowModal(true);
    };

    const handleClose = () => setShowModal(false);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const { title, url } = formData;

        if (!url.startsWith('http')) {
            alert('Please enter a valid URL.');
            return;
        }

        try {
            const response = await axios.post('https://taaiappapi.emedha.in/auth/api/api/urls', { title, url });
            setRecords([response.data, ...records]);
            handleClose();
        } catch (error) {
            console.error('URL submission failed:', error);
        }
    };

    const handleDelete = async (id) => {
        if (window.confirm('Are you sure you want to delete this record?')) {
            try {
                await axios.delete(`https://taaiappapi.emedha.in/auth/api/api/urls/${id}`);
                const updated = records.filter(item => item.id !== id);
                setRecords(updated);
            } catch (error) {
                console.error('Delete failed:', error);
            }
        }
    };

    const totalPages = Math.ceil(records.length / itemsPerPage);
    const currentRecords = records.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

    return (
        <div className="container mt-5">
            <h4 style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <IoArrowBackCircle onClick={onBack} style={{ cursor: 'pointer' }} size={28} />
                Register URL
                <button className="btn btn-primary btn-sm" onClick={handleShow}>+ Add</button>
            </h4>

            <table className="table table-bordered mt-3">
                <thead className="table-primary">
                    <tr>
                        <th>#</th>
                        <th>Title</th>
                        <th>URL</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {currentRecords.map((record, index) => (
                        <tr key={record.id}>
                            <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                            <td>{record.title}</td>
                            <td>
                                <a href={record.url} target="_blank" rel="noreferrer">Open</a>
                            </td>
                            <td>
                                <MdDelete
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => handleDelete(record.id)}
                                />
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>

            <Pagination className="justify-content-center">
                <Pagination.Prev onClick={() => setCurrentPage(p => Math.max(p - 1, 1))} disabled={currentPage === 1} />
                {[...Array(totalPages).keys()].map(p => (
                    <Pagination.Item key={p + 1} active={currentPage === p + 1} onClick={() => setCurrentPage(p + 1)}>
                        {p + 1}
                    </Pagination.Item>
                ))}
                <Pagination.Next onClick={() => setCurrentPage(p => Math.min(p + 1, totalPages))} disabled={currentPage === totalPages} />
            </Pagination>

            <Modal show={showModal} onHide={handleClose} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>Add New URL</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form onSubmit={handleSubmit}>
                        <div className="mb-3">
                            <label>Title</label>
                            <textarea
                                className="form-control"
                                name="title"
                                value={formData.title}
                                onChange={handleInputChange}
                            ></textarea>
                        </div>
                        <div className="mb-3">
                            <label>URL</label>
                            <input
                                type="url"
                                className="form-control"
                                name="url"
                                value={formData.url}
                                onChange={handleInputChange}
                                placeholder="https://example.com"
                                required
                            />
                        </div>
                        <button className="btn btn-primary">Submit</button>
                    </form>
                </Modal.Body>
            </Modal>
        </div>
    );
};


const TaaiMembership = ({ onBack }) => {
    const [showModal, setShowModal] = useState(false);
    const [formData, setFormData] = useState({ title: '', url: '' });
    const [records, setRecords] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;

    useEffect(() => {
        fetchRecords();
    }, []);

    const fetchRecords = async () => {
        try {
            const response = await axios.get('https://taaiappapi.emedha.in/auth/api/taai/api/urls');
            setRecords(response.data);
        } catch (error) {
            console.error('Error fetching records:', error);
        }
    };

    const handleShow = () => {
        setFormData({ title: '', url: '' });
        setShowModal(true);
    };

    const handleClose = () => setShowModal(false);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const { title, url } = formData;

        if (!url.startsWith('http')) {
            alert('Please enter a valid URL.');
            return;
        }

        try {
            const response = await axios.post('https://taaiappapi.emedha.in/auth/api/taai/api/urls', { title, url });
            setRecords([response.data, ...records]);
            handleClose();
        } catch (error) {
            console.error('URL submission failed:', error);
        }
    };

    const handleDelete = async (id) => {
        if (window.confirm('Are you sure you want to delete this record?')) {
            try {
                await axios.delete(`https://taaiappapi.emedha.in/auth/api/taai/api/urls/${id}`);
                const updated = records.filter(item => item.id !== id);
                setRecords(updated);
            } catch (error) {
                console.error('Delete failed:', error);
            }
        }
    };

    const totalPages = Math.ceil(records.length / itemsPerPage);
    const currentRecords = records.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

    return (
        <div className="container mt-5">
            <h4 style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <IoArrowBackCircle onClick={onBack} style={{ cursor: 'pointer' }} size={28} />
                Taai Membership  URL
                <button className="btn btn-primary btn-sm" onClick={handleShow}>+ Add</button>
            </h4>

            <table className="table table-bordered mt-3">
                <thead className="table-primary">
                    <tr>
                        <th>#</th>
                        <th>Title</th>
                        <th>URL</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {currentRecords.map((record, index) => (
                        <tr key={record.id}>
                            <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                            <td>{record.title}</td>
                            <td>
                                <a href={record.url} target="_blank" rel="noreferrer">Open</a>
                            </td>
                            <td>
                                <MdDelete
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => handleDelete(record.id)}
                                />
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>

            <Pagination className="justify-content-center">
                <Pagination.Prev onClick={() => setCurrentPage(p => Math.max(p - 1, 1))} disabled={currentPage === 1} />
                {[...Array(totalPages).keys()].map(p => (
                    <Pagination.Item key={p + 1} active={currentPage === p + 1} onClick={() => setCurrentPage(p + 1)}>
                        {p + 1}
                    </Pagination.Item>
                ))}
                <Pagination.Next onClick={() => setCurrentPage(p => Math.min(p + 1, totalPages))} disabled={currentPage === totalPages} />
            </Pagination>

            <Modal show={showModal} onHide={handleClose} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>Add New URL</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form onSubmit={handleSubmit}>
                        <div className="mb-3">
                            <label>Title</label>
                            <textarea
                                className="form-control"
                                name="title"
                                value={formData.title}
                                onChange={handleInputChange}
                            ></textarea>
                        </div>
                        <div className="mb-3">
                            <label>URL</label>
                            <input
                                type="url"
                                className="form-control"
                                name="url"
                                value={formData.url}
                                onChange={handleInputChange}
                                placeholder="https://example.com"
                                required
                            />
                        </div>
                        <button className="btn btn-primary">Submit</button>
                    </form>
                </Modal.Body>
            </Modal>
        </div>
    );
};

const Attendance = ({ onBack }) => {
    const [show, setShow] = useState(false);
    const [showBulkUpload, setShowBulkUpload] = useState(false);
    const [attendanceEntries, setAttendanceEntries] = useState([]);
    const [formData, setFormData] = useState({ name: '', email: '', mobile: '', district: '', registration: '' });
    const [isEditing, setIsEditing] = useState(false);
    const [editId, setEditId] = useState(null);
    const [file, setFile] = useState(null);

    // Pagination state
    const [currentPage, setCurrentPage] = useState(1);
    const entriesPerPage = 10;

    // Add state for searchQuery
    const [searchQuery, setSearchQuery] = useState('');

    useEffect(() => {
        fetchAttendanceEntries();
    }, []);

    const fetchAttendanceEntries = async () => {
        try {
            const response = await axios.get('https://taaiappapi.emedha.in/pages/api/api/attendance');
            setAttendanceEntries(response.data);
        } catch (error) {
            console.error('Error fetching attendance entries:', error);
        }
    };

    const handleClose = () => {
        setShow(false);
        setShowBulkUpload(false);
        setIsEditing(false);
        setFormData({ name: '', email: '', mobile: '', district: '', registration: '' });
    };

    const handleShow = () => setShow(true);
    const handleShowBulkUpload = () => setShowBulkUpload(true);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            if (isEditing) {
                await axios.put(`https://taaiappapi.emedha.in/pages/api/api/attendance/${editId}`, formData);
            } else {
                await axios.post('https://taaiappapi.emedha.in/pages/api/api/attendance', formData);
            }
            fetchAttendanceEntries();
            handleClose();
        } catch (error) {
            console.error('Error saving attendance entry:', error);
            if (error.response && error.response.data.error === 'Registration number must be unique.') {
                alert('The registration number must be unique. Please enter a different registration number.');
            } else {
                alert('An error occurred while saving the attendance entry.');
            }
        }
    };

    const handleFileChange = (e) => {
        const selectedFile = e.target.files[0];
        console.log('Selected file:', selectedFile);
        setFile(selectedFile);
    };

    const handleBulkUpload = async (e) => {
        e.preventDefault();
        const formData = new FormData();
        formData.append('file', file);

        try {
            await axios.post('https://taaiappapi.emedha.in/pages/api/api/bulkupload', formData);
            fetchAttendanceEntries();
            handleClose();
        } catch (error) {
            console.error('Error uploading bulk attendance:', error.response ? error.response.data : error.message);
        }
    };

    const handleEdit = (entry) => {
        setFormData(entry);
        setEditId(entry.id);
        setIsEditing(true);
        setShow(true);
    };

    const handleDelete = async (id) => {
        try {
            await axios.delete(`https://taaiappapi.emedha.in/pages/api/api/attendance/${id}`);
            fetchAttendanceEntries();
        } catch (error) {
            console.error('Error deleting attendance entry:', error);
        }
    };

    // Pagination logic
    const indexOfLastEntry = currentPage * entriesPerPage;
    const indexOfFirstEntry = indexOfLastEntry - entriesPerPage;
    const currentEntries = attendanceEntries.slice(indexOfFirstEntry, indexOfLastEntry);

    const totalPages = Math.ceil(attendanceEntries.length / entriesPerPage);

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    // Filter data based on the search query
    const filteredAttendees = attendanceEntries.filter(entry => {
        return (
            entry.registration?.toLowerCase().includes(searchQuery.toLowerCase()) ||
            entry.name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
            entry.email?.toLowerCase().includes(searchQuery.toLowerCase()) ||
            entry.mobile?.toLowerCase().includes(searchQuery.toLowerCase())

        );
    });

    return (
        <>

            <div className="container mt-5">
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                    {/* <IoArrowBackCircle onClick={() => window.history.back()} style={{ cursor: 'pointer', fontSize: '45px' }} /> */}
                    <IoArrowBackCircle onClick={onBack} style={{ cursor: 'pointer' }} size={28} />
                    <h1> Attendees</h1>

                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderRadius: '3px', height: '40px', border: '1px solid black', paddingLeft: '10px', width: '380px' }}>
                        <input
                            style={{ border: 'none', paddingLeft: '10px', width: '280px', outline: 'none' }}
                            type="search"
                            aria-label="Search"
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                        />
                        <CiSearch style={{ marginRight: '8px' }} />
                    </div>
                    <Button className="btn btn-primary btn-sm" onClick={handleShowBulkUpload}><FaShirtsinbulk /> Bulk Action</Button>
                    <Button className="btn btn-primary btn-sm" onClick={handleShow}>+ Add</Button>
                </div>

                {/* Modal for adding/editing attendance entries */}
                <Modal show={show} onHide={handleClose} size="lg">
                    <Modal.Header closeButton>
                        <Modal.Title>{isEditing ? 'Edit Attendees Entry' : 'Add Attendees Entry'}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form onSubmit={handleSubmit}>
                            <Form.Group controlId="formName">
                                <Form.Label>Registration No</Form.Label>
                                <Form.Control type="text" name="registration" value={formData.registration} onChange={handleChange} />
                            </Form.Group>
                            <Form.Group controlId="formName">
                                <Form.Label>Name</Form.Label>
                                <Form.Control type="text" name="name" value={formData.name} onChange={handleChange} />
                            </Form.Group>
                            <Form.Group controlId="formEmail">
                                <Form.Label>Email</Form.Label>
                                <Form.Control type="email" name="email" value={formData.email} onChange={handleChange} />
                            </Form.Group>
                            <Form.Group controlId="formMobile">
                                <Form.Label>Mobile</Form.Label>
                                <Form.Control type="text" name="mobile" value={formData.mobile} onChange={handleChange} />
                            </Form.Group>

                            <Button variant="primary" type="submit" className="mt-3">
                                {isEditing ? 'Update' : 'Submit'}
                            </Button>
                        </Form>
                    </Modal.Body>
                </Modal>

                {/* Modal for bulk upload */}
                <Modal show={showBulkUpload} onHide={handleClose} size="lg">
                    <Modal.Header closeButton>
                        <Modal.Title>Bulk Upload Attendees</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form onSubmit={handleBulkUpload}>
                            <Form.Group controlId="formFile">
                                <Form.Label>Upload File</Form.Label>
                                <Form.Control type="file" onChange={handleFileChange} required />
                            </Form.Group>
                            <Button variant="primary" type="submit" className="mt-3">Upload</Button>
                        </Form>
                    </Modal.Body>
                </Modal>

                {/* Table to display attendance entries */}
                <div className="table-responsive mt-5">
                    <table className="table">
                        <thead>
                            <tr>
                                <th>Registration</th>
                                <th>Name</th>
                                <th>Email</th>
                                <th>Mobile</th>

                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredAttendees.slice(indexOfFirstEntry, indexOfLastEntry).map((entry) => (
                                <tr key={entry.id}>
                                    <td>{entry.registration}</td>
                                    <td>{entry.name}</td>
                                    <td>{entry.email}</td>
                                    <td>{entry.mobile}</td>

                                    <td>
                                        <Button variant="warning me-3" size="sm" onClick={() => handleEdit(entry)}>Edit</Button>
                                        <Button variant="danger" size="sm" onClick={() => handleDelete(entry.id)}>Delete</Button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                {/* Pagination Controls */}
                <div className="d-flex justify-content-between mt-3">
                    <Button
                        disabled={currentPage === 1}
                        onClick={() => handlePageChange(currentPage - 1)}
                    >
                        Previous
                    </Button>
                    <div>
                        Page {currentPage} of {totalPages}
                    </div>
                    <Button
                        disabled={currentPage === totalPages}
                        onClick={() => handlePageChange(currentPage + 1)}
                    >
                        Next
                    </Button>
                </div>
            </div>
        </>
    );
};

const Gallery = ({ onBack }) => {
    const navigate = useNavigate();

    const [photos, setPhotos] = useState([]);
    const [captures, setCaptures] = useState([]);
    const [currentPhotoPage, setCurrentPhotoPage] = useState(1);
    const [currentCapturePage, setCurrentCapturePage] = useState(1);
    const itemsPerPage = 10; // Items per page

    useEffect(() => {
        // Fetch photos data

        // Fetch capture data
        const fetchCaptures = async () => {
            try {
                const response = await fetch('https://taaiappapi.emedha.in/pages/api/capture');
                const data = await response.json();
                setCaptures(data);
            } catch (err) {
                console.error('Error fetching captures:', err);
            }
        };


        fetchCaptures();
    }, []);

    const totalPhotoPages = Math.ceil(photos.length / itemsPerPage);
    const totalCapturePages = Math.ceil(captures.length / itemsPerPage);
    const currentPhotos = photos.slice((currentPhotoPage - 1) * itemsPerPage, currentPhotoPage * itemsPerPage);
    const currentCaptures = captures.slice((currentCapturePage - 1) * itemsPerPage, currentCapturePage * itemsPerPage);

    const handlePhotoPageChange = (page) => setCurrentPhotoPage(page);
    const handleCapturePageChange = (page) => setCurrentCapturePage(page);

    const handleBack = () => {
        navigate(-1);
    };


    // Function to handle status change for capture
    const handleCaptureStatusChange = async (id, newStatus) => {
        try {
            const response = await fetch('https://taaiappapi.emedha.in/pages/api/update-capture-status', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    id,
                    status: newStatus,
                }),
            });
            const data = await response.json();
            if (response.ok) {
                // Update state with new status
                setCaptures((prevCaptures) =>
                    prevCaptures.map((capture) =>
                        capture.id === id ? { ...capture, status: newStatus } : capture
                    )
                );
            } else {
                console.error('Error updating capture status:', data.error);
            }
        } catch (err) {
            console.error('Error during status update:', err);
        }
    };


    // Function to delete a capture
    const handleDeleteCapture = async (id) => {
        try {
            const response = await fetch(`https://taaiappapi.emedha.in/pages/api/capture/${id}`, {
                method: 'DELETE',
            });
            if (response.ok) {
                // Remove the capture from the state after deletion
                setCaptures((prevCaptures) => prevCaptures.filter((capture) => capture.id !== id));
            } else {
                console.error('Error deleting capture');
            }
        } catch (err) {
            console.error('Error during capture deletion:', err);
        }
    };

    return (
        <>

            <div className="container mt-5">
                <h1 style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'flex-start', marginBottom: '20px' }}>
                    <IoArrowBackCircle onClick={onBack} style={{ cursor: 'pointer' }} />

                </h1>

                <div style={{ display: 'flex', justifyContent: 'space-between' }}>


                    {/* Captures Table - Right side */}
                    <div style={{ flex: 1, marginLeft: '10px' }}>
                        <h2>Capture a moment</h2>
                        <table className="table table-bordered">
                            <thead>
                                <tr>
                                    <th>Capture a moment</th>
                                    <th>Status</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {currentCaptures.length === 0 ? (
                                    <tr><td colSpan="4">Loading...</td></tr>
                                ) : (
                                    currentCaptures.map((capture) => (
                                        <tr key={capture.id}>
                                            <td>{capture.capture ? (<img src={capture.capture} alt={`Capture ${capture.id}`} width="50" style={{ borderRadius: '5px' }} />) : ("No Image")}</td>
                                            <td>{capture.status}</td>
                                            <td>
                                                <button onClick={() => handleCaptureStatusChange(capture.id, capture.status === 'approved' ? 'Not Approved' : 'approved')} className="btn btn-primary btn-sm me-2" >
                                                    Approve
                                                </button>
                                                <button onClick={() => handleDeleteCapture(capture.id)} className="btn btn-danger btn-sm" >
                                                    Delete
                                                </button>
                                            </td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>

                        {/* Pagination for captures */}
                        <Pagination className="justify-content-center mt-4">
                            <Pagination.Prev onClick={() => setCurrentCapturePage(prev => Math.max(prev - 1, 1))} disabled={currentCapturePage === 1} />
                            {[...Array(totalCapturePages).keys()].map(page => (
                                <Pagination.Item key={page + 1} active={page + 1 === currentCapturePage} onClick={() => handleCapturePageChange(page + 1)}>
                                    {page + 1}
                                </Pagination.Item>
                            ))}
                            <Pagination.Next onClick={() => setCurrentCapturePage(prev => Math.min(prev + 1, totalCapturePages))} disabled={currentCapturePage === totalCapturePages} />
                        </Pagination>
                    </div>
                </div>
            </div>
        </>
    );
};


const Networking = ({ onBack }) => {
    const navigate = useNavigate();
    const [attendees, setAttendees] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(10);
    const [totalPages, setTotalPages] = useState(1);
    const [searchQuery, setSearchQuery] = useState('');

    const handleBack = () => {
        navigate(-1);
    };

    useEffect(() => {
        const fetchAttendees = async () => {
            try {
                const response = await axios.get('https://taaiappapi.emedha.in/pages/api/attendees');
                setAttendees(response.data);
                setTotalPages(Math.ceil(response.data.length / itemsPerPage));
            } catch (err) {
                console.error('Error fetching attendees:', err.message);
            }
        };

        fetchAttendees();
    }, [itemsPerPage]);

    const filteredAttendees = attendees.filter(attendee => {
        return (
            attendee.name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
            attendee.company?.toLowerCase().includes(searchQuery.toLowerCase()) ||
            attendee.city?.toLowerCase().includes(searchQuery.toLowerCase()) ||
            attendee.email?.toLowerCase().includes(searchQuery.toLowerCase()) ||
            attendee.mobile?.toLowerCase().includes(searchQuery.toLowerCase()) ||
            attendee.type?.toLowerCase().includes(searchQuery.toLowerCase()) ||
            attendee.interestedInLBN?.toLowerCase().includes(searchQuery.toLowerCase())
        );
    });

    const totalFilteredPages = Math.ceil(filteredAttendees.length / itemsPerPage);

    const currentAttendees = filteredAttendees.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );

    return (
        <>

            <div className="container mt-5">
                <h1 style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                    <IoArrowBackCircle onClick={onBack} style={{ cursor: 'pointer' }} />
                    Networking
                    <div>
                        <input
                            className="form-control mr-sm-2"
                            type="search"
                            placeholder="Search"
                            aria-label="Search"
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                        />
                    </div>
                </h1>

                {/* Responsive Table */}
                <div className="table-responsive">
                    <table className="table table-striped">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Name</th>
                                <th>Profile</th>
                                <th>Company</th>
                                <th>City</th>
                                <th>Mobile</th>
                                <th>Email</th>
                                <th>Products/Services</th>
                                <th>Interested In Networking</th>

                            </tr>
                        </thead>
                        <tbody>
                            {currentAttendees.length > 0 ? (
                                currentAttendees.map((attendee, index) => (
                                    <tr key={attendee.id}>
                                        <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                                        <td>{attendee.name}</td>
                                        <td>
                                            <img
                                                src={attendee.profilePic || 'default-profile-pic.jpg'}
                                                alt={`${attendee.name}'s Profile`}
                                                style={{ width: 50, height: 50, borderRadius: '50%' }}
                                            />
                                        </td>
                                        <td>{attendee.company}</td>
                                        <td>{attendee.city}</td>
                                        <td>{attendee.mobile}</td>
                                        <td>{attendee.email}</td>

                                        <td>{attendee.type}</td>
                                        <td>{attendee.interestedInLBN}</td>
                                        <td>{attendee.investment}</td>
                                        <td>{attendee.globalNetworking}</td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="12" className="text-center">No attendees found</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>

                {/* Pagination Controls */}
                <Pagination className="justify-content-center">
                    <Pagination.Prev
                        onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                        disabled={currentPage === 1}
                    />
                    {[...Array(totalFilteredPages)].map((_, pageIndex) => (
                        <Pagination.Item
                            key={pageIndex + 1}
                            active={pageIndex + 1 === currentPage}
                            onClick={() => setCurrentPage(pageIndex + 1)}
                        >
                            {pageIndex + 1}
                        </Pagination.Item>
                    ))}
                    <Pagination.Next
                        onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalFilteredPages))}
                        disabled={currentPage === totalFilteredPages}
                    />
                </Pagination>
            </div>
        </>
    );
};




const StallScans = ({ onBack }) => {
    const navigate = useNavigate();
    const [users, setUsers] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(10);
    const [searchQuery, setSearchQuery] = useState('');
    const [selectedUser, setSelectedUser] = useState(null);
    const [showModal, setShowModal] = useState(false);

    const handleBack = () => {
        navigate(-1);
    };

    useEffect(() => {
        const fetchScans = async () => {
            try {
                const response = await axios.get('https://taaiappapi.emedha.in/pages/api/api/scans-summary');
                setUsers(response.data.data || []);
            } catch (err) {
                console.error('Error fetching stall scans:', err.message);
            }
        };

        fetchScans();
    }, []);

    const filteredUsers = users.filter(user => {
        const query = searchQuery.toLowerCase();
        return (
            user.name?.toLowerCase().includes(query) ||
            user.company?.toLowerCase().includes(query) ||
            user.city?.toLowerCase().includes(query) ||
            user.email?.toLowerCase().includes(query) ||
            user.mobile?.toLowerCase().includes(query) ||
            user.stalls?.some(stall =>
                stall.stallno.toString().includes(query) ||
                stall.stallowner?.toLowerCase().includes(query) ||
                stall.stall_type?.toLowerCase().includes(query)
            )
        );
    });

    const totalPages = Math.ceil(filteredUsers.length / itemsPerPage);
    const currentUsers = filteredUsers.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );

    const handleOpenModal = (user) => {
        setSelectedUser(user);
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setSelectedUser(null);
        setShowModal(false);
    };

    return (
        <div className="container mt-5">
            <h1 style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                <IoArrowBackCircle onClick={onBack || handleBack} style={{ cursor: 'pointer' }} />
                Stall Scans
                <input
                    className="form-control w-25"
                    type="search"
                    placeholder="Search"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                />
            </h1>

            {/* Table */}
            <div className="table-responsive">
                <table className="table table-striped">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Name</th>
                            <th>Profile</th>
                            <th>Company</th>
                            <th>City</th>
                            <th>Mobile</th>
                            <th>Email</th>
                            <th>Total Scans</th>
                            <th>Stalls Scanned</th>
                        </tr>
                    </thead>
                    <tbody>
                        {currentUsers.length > 0 ? (
                            currentUsers.map((user, index) => (
                                <tr key={user.email}>
                                    <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                                    <td>{user.name}</td>
                                    <td>
                                        <img
                                            src={user.profilePic || 'default-profile-pic.jpg'}
                                            alt={`${user.name}'s Profile`}
                                            style={{ width: 50, height: 50, borderRadius: '50%' }}
                                        />
                                    </td>
                                    <td>{user.company}</td>
                                    <td>{user.city}</td>
                                    <td>{user.mobile}</td>
                                    <td>{user.email}</td>
                                    <td>{user.scan_count}</td>
                                    <td>
                                        <Button variant="dark" onClick={() => handleOpenModal(user)}>
                                            View
                                        </Button>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="9" className="text-center">No data found</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            {/* Pagination */}
            <Pagination className="justify-content-center mt-3">
                <Pagination.Prev
                    onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                    disabled={currentPage === 1}
                />
                {[...Array(totalPages)].map((_, pageIndex) => (
                    <Pagination.Item
                        key={pageIndex + 1}
                        active={pageIndex + 1 === currentPage}
                        onClick={() => setCurrentPage(pageIndex + 1)}
                    >
                        {pageIndex + 1}
                    </Pagination.Item>
                ))}
                <Pagination.Next
                    onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                    disabled={currentPage === totalPages}
                />
            </Pagination>

            {/* Modal for Stalls */}
            <Modal show={showModal} onHide={handleCloseModal} size="lg" centered>
                <Modal.Header closeButton>
                    <Modal.Title>Stalls Scanned by {selectedUser?.name}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {selectedUser?.stalls?.length > 0 ? (
                        <div className="row">
                            {selectedUser.stalls.map((stall, i) => (
                                <div className="col-md-6 mb-4" key={i}>
                                    <div className="card shadow-sm border-0" style={{ borderRadius: '15px' }}>
                                        <div className="card-body">
                                            <h5 className="card-title text-dark fw-bold">Stall #{stall.stallno}</h5>
                                            <p className="card-text mb-1"><strong>Owner:</strong> {stall.stallowner}</p>
                                            <p className="card-text"><strong>Type:</strong> {stall.stall_type}</p>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    ) : (
                        <p className="text-muted">No stalls found.</p>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseModal}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};


const BizSession = ({ onBack }) => {
    const [showModal, setShowModal] = useState(false);

    const [formData, setFormData] = useState({
        subject: '',
        speaker: '',
        remarks: '',
        schedule: '',
        date: ''
    });

    const [events, setEvents] = useState([]);
    const [editingId, setEditingId] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;

    useEffect(() => {
        fetchEvents();
    }, []);

    const fetchEvents = async () => {
        try {
            const response = await fetch('https://taaiappapi.emedha.in/pages/api/api/session');
            const data = await response.json();

            console.log(data)
            if (Array.isArray(data)) {
                const groupedEvents = data.reduce((acc, event) => {
                    const eventDate = new Date(event.date).toLocaleDateString();
                    if (!acc[eventDate]) acc[eventDate] = [];
                    acc[eventDate].push(event);
                    return acc;
                }, {});

                const sortedDates = Object.keys(groupedEvents).sort((a, b) => new Date(a) - new Date(b));

                const sortedEvents = {};
                sortedDates.forEach(date => {
                    sortedEvents[date] = groupedEvents[date];
                });

                setEvents(sortedEvents);

            } else {
                console.error('Expected an array but received:', data);
                setEvents({});
            }
        } catch (error) {
            console.error('Error fetching events:', error);
            setEvents({});
        }
    };

    const handleShow = (event = null) => {
        if (event) {
            setFormData({
                subject: event.subject,
                speaker: event.speaker,
                remarks: event.remarks,
                schedule: event.schedule,
                date: event.date,
            });
            setEditingId(event.id);
        } else {
            setFormData({ subject: '', speaker: '', remarks: "", schedule: '', date: '' });
            setEditingId(null);
        }
        setShowModal(true);
    };


    const handleClose = () => setShowModal(false);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };


    const handleSubmit = async (e) => {
        e.preventDefault();

        const method = editingId ? 'PUT' : 'POST';
        const url = editingId
            ? `https://taaiappapi.emedha.in/pages/api/api/session/${editingId}`
            : 'https://taaiappapi.emedha.in/pages/api/api/session';

        const eventData = {};
        if (formData.subject) eventData.subject = formData.subject;
        if (formData.speaker) eventData.speaker = formData.speaker;
        if (formData.remarks) eventData.remarks = formData.remarks;
        if (formData.schedule) eventData.schedule = formData.schedule;
        if (formData.date) eventData.date = formData.date;

        try {
            const response = await fetch(url, {
                method,
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(eventData),
            });

            if (response.ok) {
                fetchEvents();
                handleClose();
            } else {
                console.error('Error submitting event:', response.statusText);
            }
        } catch (error) {
            console.error('Error submitting event:', error);
        }
    };


    const handleDelete = async (eventId) => {
        if (window.confirm('Are you sure you want to delete this event?')) {
            const response = await fetch(`https://taaiappapi.emedha.in/pages/api/api/session/${eventId}`, {
                method: 'DELETE',
            });
            if (response.ok) {
                fetchEvents(); // Refresh events list
            } else {
                console.error('Error deleting event:', response.statusText);
            }
        }
    };


    // Pagination logic for dates (not events directly)
    const totalPages = Math.ceil(Object.keys(events).length / itemsPerPage);
    const currentDates = Object.keys(events).slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

    return (
        <>
            <>
                <div className="container mt-5" style={{ fontSize: '14px' }}>
                    <h4 style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', border: "1px solid grey", padding: '5px' }}>
                        <IoArrowBackCircle onClick={onBack} style={{ cursor: 'pointer' }} size={28} />
                        Biz Session
                        <button style={{ backgroundColor: '#00a2ffff', color: 'white', border: 'none', padding: '4px 16px', fontSize: '14px', cursor: 'pointer', marginBottom: '10px', }} onClick={handleShow}>+ Add</button>
                    </h4>

                    <Table striped bordered hover responsive="sm">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Schedule</th>
                                <th>Subject</th>
                                <th>Speaker</th>
                                <th>Remarks </th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentDates.map((date, index) => (
                                <React.Fragment key={date}>
                                    <tr>
                                        <td colSpan="7" style={{ textAlign: 'center', fontWeight: 'bold' }}>
                                            {new Date(date).toLocaleDateString('en-US', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}
                                        </td>
                                    </tr>
                                    {Array.isArray(events[date]) && events[date].map((event, eventIndex) => (
                                        <tr key={event.id}>
                                            <td>{(currentPage - 1) * itemsPerPage + index + eventIndex + 1}</td>
                                            <td>{event.schedule}</td>
                                            <td>{event.subject}</td>
                                            <td>{event.speaker || ''}</td>
                                            <td>{event.remarks || ''}</td>
                                            <td>
                                                <FaEdit className='me-3' style={{ cursor: 'pointer' }} onClick={() => handleShow(event)} />
                                                <MdDelete style={{ cursor: 'pointer' }} onClick={() => handleDelete(event.id)} />
                                            </td>
                                        </tr>
                                    ))}
                                </React.Fragment>
                            ))}
                        </tbody>
                    </Table>

                    {/* Modal for Adding/Editing Events */}
                    <Modal show={showModal} onHide={handleClose} size="lg">
                        <Modal.Header closeButton>
                            <Modal.Title>{editingId ? 'Edit Event' : 'Add Event'}</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <form onSubmit={handleSubmit}>
                                <div className="mb-3">
                                    <label htmlFor="schedule" className="form-label">Schedule Time</label>
                                    <input type="text" className="form-control" id="schedule" name="schedule" value={formData.schedule} onChange={handleInputChange} style={{ borderRadius: "0px" }} />
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="subject" className="form-label">Subject</label>
                                    <textarea type="text" className="form-control" id="subject" name="subject" value={formData.subject} onChange={handleInputChange} style={{ borderRadius: "0px" }} />
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="speaker" className="form-label">Speaker</label>
                                    <input type="text" className="form-control" id="speaker" name="speaker" value={formData.speaker} onChange={handleInputChange} style={{ borderRadius: "0px" }} />
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="remarks" className="form-label">Remarks</label>
                                    <textarea type="text" className="form-control" id="remarks" name="remarks" value={formData.remarks} onChange={handleInputChange} style={{ borderRadius: "0px" }} />
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="date" className="form-label">Date</label>
                                    <input type="date" className="form-control" id="date" name="date" value={formData.date} onChange={handleInputChange} min={new Date().toISOString().split("T")[0]} style={{ borderRadius: "0px" }} />
                                </div>
                                <button className="btn btn-primary btn-sm" type="submit">Submit</button>
                            </form>
                        </Modal.Body>
                    </Modal>

                    {/* Pagination Controls */}
                    <Pagination className="justify-content-center mt-4">
                        <Pagination.Prev onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))} disabled={currentPage === 1} />
                        {[...Array(totalPages).keys()].map(page => (
                            <Pagination.Item key={page + 1} active={page + 1 === currentPage} onClick={() => setCurrentPage(page + 1)}>
                                {page + 1}
                            </Pagination.Item>
                        ))}
                        <Pagination.Next onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))} disabled={currentPage === totalPages} />
                    </Pagination>
                </div>
            </>
        </>
    );
};

const Sliders = ({ onBack }) => {
    const [showModal, setShowModal] = useState(false);
    const [formData, setFormData] = useState({ image: null });
    const [sliders, setSliders] = useState([]);
    const [editId, setEditId] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;

    useEffect(() => {
        fetchSliders();
    }, []);

    const fetchSliders = async () => {
        try {
            const response = await axios.get('https://taaiappapi.emedha.in/auth/api/api/sliders');
            setSliders(response.data);
        } catch (error) {
            console.error('Error fetching sliders:', error);
        }
    };

    const handleShow = (slider = null) => {
        if (slider) {
            setFormData({ image: null });
            setEditId(slider.id);
        } else {
            setFormData({ image: null });
            setEditId(null);
        }
        setShowModal(true);
    };

    const handleClose = () => setShowModal(false);

    const handleInputChange = (e) => {
        const { files } = e.target;
        setFormData({ image: files[0] });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const { image } = formData;
        const dataToSend = new FormData();
        if (image) {
            dataToSend.append('image', image);
        }

        try {
            if (editId !== null) {
                await axios.put(`https://taaiappapi.emedha.in/auth/api/api/sliders/${editId}`, dataToSend);
            } else {
                await axios.post('https://taaiappapi.emedha.in/auth/api/api/sliders', dataToSend);
            }
            fetchSliders();
            handleClose();
        } catch (error) {
            console.error('Error saving slider:', error);
        }
    };

    const handleDelete = async (id) => {
        if (window.confirm('Are you sure you want to delete this slider?')) {
            try {
                await axios.delete(`https://taaiappapi.emedha.in/auth/api/api/sliders/${id}`);
                fetchSliders();
            } catch (error) {
                console.error('Error deleting slider:', error);
            }
        }
    };

    const totalPages = Math.ceil(sliders.length / itemsPerPage);
    const currentSliders = sliders.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

    return (
        <div className="container mt-5">
            <h4 style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', border: "1px solid grey", padding: '5px' }}>
                <IoArrowBackCircle onClick={onBack} style={{ cursor: 'pointer' }} size={28} />
                SLIDERS
                <button style={{ backgroundColor: '#00a2ffff', color: 'white', border: 'none', padding: '4px 16px', fontSize: '14px', cursor: 'pointer', marginBottom: '10px' }} onClick={() => handleShow()}>+ Add</button>
            </h4>

            <div className="table-responsive">
                <table className="table table-bordered table-striped">
                    <thead className="table-primary">
                        <tr>
                            <th>#</th>
                            <th>Image</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {currentSliders.map((slider, index) => (
                            <tr key={slider.id}>
                                <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                                <td><img src={slider.imageUrl} alt="Slider" style={{ width: '100px', height: '50px', objectFit: 'cover' }} /></td>
                                <td>
                                    <FaEdit className='me-3' style={{ cursor: 'pointer' }} onClick={() => handleShow(slider)} />
                                    <MdDelete style={{ cursor: 'pointer' }} onClick={() => handleDelete(slider.id)} />
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            <Modal show={showModal} onHide={handleClose} size="lg">
                <Modal.Header closeButton><Modal.Title>{editId !== null ? 'EDIT SLIDER' : 'ADD SLIDER'}</Modal.Title></Modal.Header>
                <Modal.Body>
                    <form onSubmit={handleSubmit}>
                        <div className="mb-3">
                            <label htmlFor="image" className="form-label">Upload Image</label>
                            <input type="file" className="form-control" id="image" name="image" accept="image/*" onChange={handleInputChange} required={editId === null} style={{ borderRadius: "0px" }} />
                        </div>
                        <button className="btn btn-primary btn-sm" type="submit">Submit</button>
                    </form>
                </Modal.Body>
            </Modal>

            <Pagination className="justify-content-center mt-4">
                <Pagination.Prev onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))} disabled={currentPage === 1} />
                {[...Array(totalPages).keys()].map(page => (
                    <Pagination.Item key={page + 1} active={page + 1 === currentPage} onClick={() => setCurrentPage(page + 1)}>
                        {page + 1}
                    </Pagination.Item>
                ))}
                <Pagination.Next onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))} disabled={currentPage === totalPages} />
            </Pagination>
        </div>
    );
};


export default Dashboard;

